import { Component, OnInit, AfterContentInit, Input, Renderer2, DoCheck, AfterViewChecked, AfterViewInit, TemplateRef, HostListener, Injectable, Inject, ElementRef, ViewChild, OnChanges, ChangeDetectorRef, OnDestroy, NgZone } from "@angular/core";
import { Observable, Subscription, combineLatest, Subject, from, forkJoin } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { getInjectorIndex } from "@angular/core/src/render3/di";
import { Location } from '@angular/common';
import { BsModalService, BsModalRef, ModalDirective } from "ngx-bootstrap/modal";
import {
  Router, NavigationEnd, ActivatedRoute, ActivationEnd, RouterEvent, NavigationStart, Scroll, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate
} from "@angular/router";
import { DOCUMENT, Meta, Title } from "@angular/platform-browser";
import { ScrollEvent } from "ngx-scroll-event";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { SnackbarService } from 'ngx-snackbar';
import { MatSnackBar } from '@angular/material';
import { VgAPI, VgControlsHidden } from 'videogular2/core';
import { PlatformLocation, ViewportScroller } from '@angular/common';
import { filter, tap, take, finalize } from "rxjs/operators";
import { Gallery, GalleryItem, ImageItem, VideoItem, ThumbnailsPosition, ImageSize, CounterPosition, LoadingStrategy } from '@ngx-gallery/core';
import { LIGHTBOX_CONFIG, Lightbox, LightboxComponent, LightboxModule } from "@ngx-gallery/lightbox";
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxUiLoaderService } from 'ngx-ui-loader';
declare var jQuery: any;
import { NgNavigatorShareService } from 'ng-navigator-share';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faEllipsisH, faCommentAlt, faLink, faPrint, faMinus, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faLinkedinIn, faWhatsapp, faGooglePlusG, faPinterestP, faFacebookMessenger, faTelegramPlane, faTumblr, faVk, faRedditAlien, faMix, faXing, faLine } from '@fortawesome/free-brands-svg-icons';
import { CurrentMenuStateService } from "src/app/services/current-menu-state.service";
import { LocationService } from "src/app/services/location.service";
import { UnlServiceService } from "src/app/services/unl-service.service";
import { UnlAdsService } from "src/app/services/unl.ads.service";
import { FsDocument, FsDocumentElement } from "src/app/interfaces/fullscreen.type";
import { AdType } from "../../desktop-ad/desk-ad-type";
import { environment } from "src/environments/environment";
import { ShareService } from "src/app/services/share-service.service";
@Component({
  selector: "app-dynamic-contentd",
  templateUrl: "./dynamic-content.component.html",
  styleUrls: ["./dynamic-content.component.scss"],
  providers: [NgbCarouselConfig]
})
export class DynamicContentComponentd implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {

  @ViewChild('loader') redirectTemplate: ElementRef;
  @ViewChild('template') videoTemplate: TemplateRef<any>;
  @ViewChild('content') searchtemp: TemplateRef<any>;
  @ViewChild('lightbox') lightbox;
  @ViewChild('lightboxTitle') Lightboxtitle;
  @ViewChild('scrollableContainer') scrollableContainer: ElementRef;
  private startY: number = 0;
  private currentY: number = 0;
  @ViewChild('imaAds') imaAds: TemplateRef<any>;

  list: any[];
  sli = 2;
  loaderText: string = `<img src="assets/loading_pagenation.gif" class="loaderclr">`;
  twindow = window as any;
  urlnum = 1;
  viewallpage = false;
  currentLayout = "normal";
  va = 2;
  cArr;
  Vtitle;
  currentMenu;
  modalRef: BsModalRef;
  photo;
  descCurrentnodeId;
  val: any;
  i;
  loadMenurIndex = 0;
  description;
  indexcount = 14;
  mIndex;
  private _albums = [];
  albumsLightbox = [];
  PHOTOarray = [];
  item;
  rmi;
  videosandphotos;
  getrmdetails = {};
  rmdetailsarray = [];
  getrmdetailsarray = [];
  _opened: boolean = false;
  vparray = [];
  vp = 0;
  vidTermId;
  selectvps = "";
  vpcontent = [];
  currentvp: 0;
  public fixed: boolean = false;
  show;
  vidCatagories;
  videoCatList;
  vidCatagorieslink = [];
  phtoCatagories;
  photoCatList;
  catagoryIdentifier;
  detailsArrayIndex = 2;
  increment = 4;
  viewallpart: any;
  vaIndex: any;
  screenHeight: number = 0;

  dynHeight = this.screenHeight * 0.8;
  maTop: number;
  tpc: any;
  tpcp: any;
  pg = 1;
  viewAllTitle;
  adRedirect = [];
  nodeId;
  searchTitle;
  searchvalue;
  searchkey;
  issearch = false;
  issearch1 = false;
  radval: number = 2;
  isPhotosVideos = null;
  issearch2 = false;
  searchJson;
  trendJson;
  searchfix;
  templatemodal;
  isBoolean: boolean = false;
  termid;
  subscriptions: Subscription[] = [];
  autoplayboolean = true;
  Adarray;
  moreDetailsArray;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  modalImgindex = 0;
  modalImglength: number;
  modalImgtitle: any;
  modalImgheight: number;
  viewallurlNumpc: number;
  viewallmindex: any;
  checkArray: any;
  snackMsg: any;
  searchScreenHeight;
  vidcatid;
  vidid;
  adID;
  nativeShareData;
  vidtext;
  vidCatname: any = 'videos';
  preload: string = 'auto';
  api: VgAPI;
  config = {
    keyboard: true
  };
  isModalOpen = true;
  items: GalleryItem[];
  videos = [];
  adImparr = [];
  isLightbxclsd: string;
  private apiurl: string;
  loaderH: number;
  overLayT: boolean = false;
  isPortrait = true;
  conPP: boolean;
  caption = jQuery(this).data('caption') || '';
  scrollPosition: any = 0;
  scrollp: any;
  indexL;
  searchpage = 0;
  pagetype;
  vidcattext;
  currentpagedetails = [];
  locname;
  _routelistner: any;
  _pagination_ad_index = 0;
  loadingarr$: any = {};
  datadomain: string = "";
  skeletonData = Array.from({ length: 19 });
  allLoading = Array.from({ length: 1 });
  partiesLoading = Array.from({ length: 3 });
  renderTimes = Array.from({ length: 8 });
  isLoading: boolean = true;
  pageLoading: boolean = false;
  newsLoading: boolean = false;
  viewLoading: boolean = false;
  ismuted: boolean = false;
  _iOSDevice: boolean = false;
  phototabs: any = {
    recent:true,mostviewed:false
  };
  photocontentrecent: any = [];
  photocontentmost: any = [];
  videotabs: any = {
    recent:true,mostviewed:false
  };
  videocontentrecent: any = [];
  videocontentmost: any = [];
  tpc_photosrecent: any;
  tpcp_photosrecent: any;
  pg_photosrecent=1;
  tpc_photosmost: any;
  tpcp_photosmost: any;
  pg_photosmost=1;
  tpc_videosrecent: any;
  tpcp_videosrecent: any;
  pg_videosrecent=1;
  tpc_videosmost: any;
  tpcp_videosmost: any;
  pg_videosmost=1;
  adSetIndex_photosrecent = 0;
  detailsArrayIndex_photosrecent = 2;
  adSetIndex_photosmost = 0;
  detailsArrayIndex_photosmost = 2
  adSetIndex_videosrecent = 0;
  detailsArrayIndex_videosrecent = 2;
  adSetIndex_videosmost = 0;
  detailsArrayIndex_videosmost = 2
  isModalOpen1: boolean = false;
  videoForCpDc: any = null;
  showAdPlayIcon: boolean = false;
  showAdPlayIcon1: boolean  = true;
  AdType = AdType;
  currentSub: Subscription;
  currentSub1: Subscription;
  isSharing: boolean;
  viewLoading1: boolean = false;
  constructor(
    private http: HttpClient,
    private locationService: LocationService,
    private unlServiceService: UnlServiceService,
    private unlAdsService: UnlAdsService,
    private modalService: BsModalService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private activeRoute: ActivatedRoute,
    private searchService: NgbModal,
    config: NgbCarouselConfig,
    private loaderModal: BsModalService,
    private shareService: ShareService,
    private changeDetection: ChangeDetectorRef,
    private snackbarService: SnackbarService,
    private renderer: Renderer2,
    private el: ElementRef,
    private snackBar: MatSnackBar,
    private location: PlatformLocation,
    private location2: Location,
    @Inject(DOCUMENT) private doc: Document,
    public gallery: Gallery,
    public lightBoxRef: Lightbox,
    private spinn: NgxSpinnerService,
    private ngxService: NgxUiLoaderService,
    private controlsHidden: VgControlsHidden,
    private ngZone: NgZone,
    private viewportScroller: ViewportScroller,
    private title: Title,
    private meta: Meta,
    private ngNavigatorShareService: NgNavigatorShareService,
    private currentMenuStateService: CurrentMenuStateService,
    private elementRef: ElementRef,
  ) {
    // super();
    this.datadomain = this.unlServiceService.basepath;
    library.add(faEnvelope, faFacebookF, faLinkedinIn, faTwitter, faWhatsapp, faGooglePlusG, faPinterestP, faFacebookMessenger, faTelegramPlane, faTumblr, faVk, faRedditAlien, faMix, faEllipsisH, faCommentAlt, faLink, faPrint, faMinus, faXing, faLine, faCheck);
    location.onPopState(() => this.closeModal());
    this.unlServiceService.setMenuIndex();
    this.indexL = this.unlServiceService.indexL;
    config.interval = 3000;
    this._routelistner = router.events.subscribe(event => {
      this.rmdetailsarray = [];
      if (event instanceof NavigationStart) {
      } else if (event instanceof NavigationEnd) {
        this.adImparr = [];
        const routeParams = this.activeRoute.snapshot.params;

        if (this.activeRoute.firstChild != null) {
          this.activeRoute.firstChild.paramMap.pipe(tap()).subscribe(params => {
            this.searchkey = params.get('searchkey');
            this.vidcatid = params.get('vidcatid');
            if (params.get('vidid')) {
              this.vidid = params.get('vidid');
            } else if (params.get('menuindex')) {
              this.mIndex = params.get('menuindex');
              this.rmi = params.get('rmiid');
            } else {
              if (this.activeRoute.firstChild.firstChild != null) {
                this.activeRoute.firstChild.firstChild.paramMap.pipe(tap()).subscribe(para => {
                  this.vidid = para.get('vidid');
                });
              } else {
                this.vidid = '';
              }
            }
            this.currentvp = 0;
          });
        } else {
          this.searchkey = '';
          this.vidcatid = '';
          this.vidid = '';
        }
        var ctype = routeParams.ctype;
        this.pagetype = ctype;
        this.termid = routeParams.termid;
        this.ngNavigatorShareService = ngNavigatorShareService;
        var fancyboxHash = window.location.hash;
        if (fancyboxHash && fancyboxHash != '#selectlocation') {
          var photo_id = fancyboxHash.split('/')[2];
          photo_id = photo_id.split('-')[0];
          this.http.get(
            this.unlServiceService.nodeurl + photo_id + this.unlServiceService.desc_Page
          ).subscribe(val => {
            this.openSlideshow1(val);
          });


          // if(window.location.href.indexOf("photoalbum") <= -1) {   
          //   jQuery.fancybox.close();
          // }
          //jQuery(fancyboxHash).fancybox().trigger('click');
        }
        if (this.termid == undefined && this.termid == 0) {
          this.unlServiceService.setTermId("all");
        } else {
          this.unlServiceService.setTermId(this.termid);
        }
        /* This is line which cause multiple or unnessary json calls issue*/
        this.isBoolean = true;
        //this.startApp(-1);

        this.onOurInit();

        if (typeof (this.rmi) != "undefined" && this.rmi !== null && (this.currentLayout == 'normal' || this.currentLayout == 'vall')) {
          var tt = this.unlServiceService.menus[this.rmi].title;
          if (tt != 'ALL' && this.rmi != 0)
            $("#toptitle").text(tt);
          else
            $("#toptitle").text('ALL');
        }

        if (window.location.href.indexOf("play") > -1) {
          if (this.modalRef == undefined)
            this.http.get(
              this.unlServiceService.nodeurl + this.vidid + this.unlServiceService.desc_Page
            ).subscribe(val => {
              this.videoPlayer(val);
            });
        }
        if (window.location.href.indexOf("photoalbum") > -1 && this.vidid != '') {
          this.http.get(
            this.unlServiceService.nodeurl + this.vidid + this.unlServiceService.desc_Page
          ).subscribe(val => {
            this.openSlideshow(0, val);
          });
        }
        if (this.termid != "all") {
          this.http.get(this.unlServiceService.getTermID(this.termid)).subscribe(val => {
            if (val[0].term == "All Cities" || val[0].term == "All States") {
              this.locname = JSON.parse(val[0].termlist)[1].name + ' ';
              this.metadata(this.locname);
            } else {
              this.locname = val[0].term + ' ';
              this.metadata(this.locname);
            }
          });
        } else {
          this.locname = '';
          this.metadata(this.locname);
        }

      }
    });

    this.currentSub1 =  this.currentMenuStateService.currentState$.subscribe(res => {
        this.isPhotosVideos  = res.menu.toUpperCase() === 'VIDEOS' || res.menu.toUpperCase() === 'PHOTOS'
    });
  }
  // ngAfterViewChecked() {
  //   this.viewportScroller.setOffset([0, 64]);
  //   this.viewportScroller.setHistoryScrollRestoration('auto');

  //   this.router.events.pipe(filter(element => element instanceof Scroll)).subscribe((element: any) => {
  //     this.viewportScroller.scrollToAnchor(element.anchor);
  //   });
  // }
  getnightclub;
  startApp(index: number) {
    this.show = false;
    if (this.isBoolean) {
      if (index < 0) {
        this.rmi = this.locationService.getrmindex()[0];
        this.item = this.locationService.getrmindex()[1];
      } else {
        this.rmi = index;
        this.item = this.unlServiceService.getcMenu(this.rmi);
      }

      if (this.searchkey) {
        this.openSm('direct', this.searchkey, this.rmi);
      } else if (this.vidcatid) {
        this.vidTermId = this.vidcatid;
        this.catagories();
        this.getAD();
        this.currentvp=0;
        this.getVideosPhotosCat(this.rmi, 0);
        this.getVideosPhotosCat(this.rmi, 1);
      } else if (window.location.href.indexOf("viewall") > -1) {
        // $("#pageloaderhome").show();
        this.getAD();
        this.viewallcontent(this.mIndex);
      } else {
        this.vidTermId = 'all';
        if (this.rmi == 0 || this.rmi == 'undefined') {
          this.getn();
        } else if (this.rmi > 0) {
          this.getnight();
        }
        this.getAD();
        this.loadMenurIndex = 0;
        this.getrmdetailsarray = [];
        this.getrightmenuitem();
        //this.changemenuarray();
        // this.getVideosPhotos(this.rmi, this.vp,undefined);
        this.catagories();
        // this.scrollFn();
        // this.scrollableVidPhtos();
        this.searchvalue = '';
        this.currentLayout = "normal";
        this.tpcp = '';
        this.tpc = '';
        this.pg = 1;
      }
    }

    if (this.rmi === 13) {
      this.sli = 10
    }
    else {
      this.sli = 2
    }
  }

  metadata(locname) {
    if (this.rmi == undefined)
      this.rmi = this.locationService.getrmindex()[0];
    var item: any = this.unlServiceService.getcMenu(this.rmi);
    this.nativeShareData = this.item;
    if (item.title == "RESTAURANTS") {
      var metatitle = locname + item.metatitle.replace('| ' + this.unlServiceService.sitename, 'in ' + locname + ' | ' + this.unlServiceService.sitename);
    } else if (item.title == "ALL") {
      var metatitle = item.metatitle.replace(this.unlServiceService.sitename + ' - ', this.unlServiceService.sitename + ' - ' + locname);
    } else {
      var metatitle = locname + item.metatitle;
    }
    if (locname) {
      var metakeys = locname.slice(0, -1) + ', ' + item.metakeywords;
    } else {
      var metakeys: string = item.metakeywords;
    }
    var metadesc = item.metadescription.replace('source for ', 'source for ' + locname);
    var metaabs = item.metaabstract.replace('source for ', 'source for ' + locname);

    if (window.location.href.indexOf("viewall") <= -1) {
      this.title.setTitle(metatitle);
      this.meta.updateTag({ name: 'title', content: metatitle });
      this.meta.updateTag({ property: 'og:title', content: metatitle });
      this.meta.updateTag({ name: 'twitter:title', content: metatitle });
    }
    this.nativeShareData.keywords = metakeys;
    this.nativeShareData.url = window.location.href.replace(window.location.origin + '/', this.unlServiceService.basepath);
    this.meta.updateTag({ name: 'description', content: metadesc });
    this.meta.updateTag({ property: 'og:description', content: metadesc });
    this.meta.updateTag({ name: 'twitter:description', content: metadesc });
    this.meta.updateTag({ name: 'abstract', content: metaabs });
    this.meta.updateTag({ name: 'keywords', content: metakeys });
    this.meta.updateTag({ name: 'news_keywords', content: metakeys });
    this.meta.updateTag({ property: 'og:url', content: this.nativeShareData.url });
    this.meta.updateTag({ name: 'twitter:url', content: this.nativeShareData.url });
    this.meta.updateTag({ property: 'og:image', content: this.unlServiceService.basepath + 'sites/default/files/imagecache/socialshare/Nightlife-Television.jpg' });
    this.meta.updateTag({ property: 'og:image:width', content: '620' });
    this.meta.updateTag({ property: 'og:image:height', content: '349' });
    this.meta.updateTag({ name: 'copyright', content: 'Copyright © ' + (new Date()).getFullYear() + ', ' + this.unlServiceService.sitename });
  }
  // nativeShare() {
  //   this.ngNavigatorShareService.share({
  //     title: this.unlServiceService.sitename,
  //     text: this.nativeShareData.text,
  //     url: this.nativeShareData.url
  //   }).then((response) => {
  //     console.log(response);
  //   })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }
  nativeShare() {
    if (environment.isMoblie) {
      this.ngNavigatorShareService.share({
        title: this.unlServiceService.sitename,
        text: this.nativeShareData.title,
        url: this.nativeShareData.url
      }).then((response) => {
        console.log(response);
        this.isSharing = false; 
      })
        .catch((error) => {
          console.log(error);
          this.isSharing = false; 
        });
    } else {
      this.shareService.updateState(
        {
          title: this.unlServiceService.sitename,
          text: this.nativeShareData.title,
          url: this.nativeShareData.url,
          platform: 'all'
        }
      )
    }
  }
  ngOnInit() {
    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        setTimeout(() => {
          this.viewLoading = false;
        },2000)
      }
    });
    this.getCurrentState();

 // setTimeout(function () {
    //   this.getScreenSize(event);
    // }, 3000);

    LightboxModule.withConfig({
      panelClass: 'fullscreen'
    })
    this.twindow.my = {};
    this.twindow.my.unlvideo = this.twindow.my.unlvideo || {};
    this.twindow.my.unlvideo.toggleScrn = this.setFullScreen.bind(this);
    if( !this.twindow.my.location.hash && window.addEventListener ){
      this.twindow.my.addEventListener("load", function() {
          setTimeout(function(){
            this.twindow.my.scrollTo(0, 0);
          }, 0);
      });
      this.twindow.my.addEventListener( "orientationchange",function() {
          setTimeout(function(){
            this.twindow.my.scrollTo(0, 0);
          }, 0);
      });
      this.twindow.my.addEventListener( "touchstart",function() {
           setTimeout(function(){
            this.twindow.my.scrollTo(0, 0);
           }, 0);
       });
     }
     document.addEventListener('click', this.handleClick);
     //this.getCurrentState();
  }

  onNavigation(event: NavigationStart) {

  }

  
  // onTouchStart(event: TouchEvent, overlayId: number, adOverlayId: number): void {
  //   this.startY = event.touches[0].pageY;
  // }

  // onTouchMove(event: TouchEvent, overlayId: number, adOverlayId: number): void {
  //   console.log('.....')
  //   this.currentY = event.touches[0].pageY;
  //   const diffY = this.startY - this.currentY;

  //   const overlayElement = this.elementRef.nativeElement.querySelector('#overlay-' + overlayId);
  //   if (overlayElement) {
  //     const adOverlay = overlayElement.querySelector('.ad-overlay-' + adOverlayId);
  //     if (adOverlay) {
  //       this.renderer.setProperty(adOverlay, 'scrollTop', adOverlay.scrollTop + diffY);
  //     }
  //   }

  //   this.startY = this.currentY; // Update startY for the next touchmove event
  // }

  public onOurInit() {
    const queryParams = this.activeRoute.snapshot.queryParams;
    const routeParams = this.activeRoute.snapshot.params;
    var ctype = routeParams.ctype;
    var termid = routeParams.termid;
    if (ctype !== undefined) {
      var cIndex = this.unlServiceService.getIndexBycType(ctype);
      this.unlServiceService.setTermId(termid);
      this.startApp(cIndex);
    } else {
      // this.activeRoute.parent.params.subscribe((params) => { 
      //     this.pagetype = ctype = params.ctype;
      //     this.unlServiceService.setTermId(params.termid);
      //     this.termid = termid = params.termid;
      // });
      if (termid == undefined || termid === 0) {
        this.unlServiceService.setTermId("all");
        this.startApp(-1);
        document.getElementById('toptitle').innerHTML = 'ALL';
      } else {
        this.unlServiceService.setTermId(termid);
        this.startApp(cIndex);
      }
    }
  }
  openModal(msg: TemplateRef<any>, isVideoPhoto: boolean, isVideo: boolean) {
    this.isModalOpen = false;
    if (isVideoPhoto) {
      this.modalRef = this.modalService.show(msg, { class: "searchMdl modal-dialog-centered", backdrop: false, ignoreBackdropClick: true });
      this.modalService.config.backdrop = false;
      jQuery("#searchvaluepopup").focus();
    } else {
      if (isVideo !== undefined) {
        this.modalRef = this.modalService.show(msg, { class: 'modal-sm modalsizecls', backdrop: true, ignoreBackdropClick: true });
      }
      if (isVideoPhoto !== undefined) {
        this.modalService.config.backdrop = false;
      }
    }
    //alert('test'+this.Vtitle);
    const _combine = combineLatest(
      this.modalService.onShow,
      this.modalService.onShown,
      this.modalService.onHide,
      this.modalService.onHidden
    ).subscribe(() => this.changeDetection.markForCheck());
    this.subscriptions.push(
      this.modalService.onShow.subscribe((reason: string) => {
        //console.log(`onShow event has been fired`);
      })
    );
    this.subscriptions.push(
      this.modalService.onShown.subscribe((reason: string) => {
        //console.log(`onShown event has been fired`);
        this.isModalOpen = false;
      })
    );
    this.subscriptions.push(
      this.modalService.onHide.subscribe((reason: string) => {
        const _reason = reason ? `, dismissed by ${reason}` : '';
        //console.log(`onHide event has been fired${_reason}`);
        if (this.currentLayout != 'search') {
          this.isModalOpen = false;
          // window.history.forward();
        }
      })
    );
    this.subscriptions.push(
      this.modalService.onHidden.subscribe((reason: string) => {
        const _reason = reason ? `, dismissed by ${reason}` : '';
        //console.log(`onHidden event has been fired${_reason}`);
        this.unsubscribe();
        this.isModalOpen = true;
      })
    );
    this.subscriptions.push(_combine);
  }
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
  closeModal() {
    if (window.location.href.indexOf("play") > -1) {
      var currlink = window.location.pathname.split('/play/')[0];
      currlink = currlink.substring(1);
      console.log(currlink);
      this.router.navigateByUrl('/', { skipLocationChange: true })
        .then(succeeded => {
          if (succeeded) {
            this.router.navigate([currlink])
          } else {
            this.location2.go(currlink.replace('n/', ''));
          }
        })
        .catch(error => {
          console.log(error);
        });
      //.then(() => this.router.navigate([currlink]));
      this.metadata(this.locname);
    }
    if (this.isLightbxclsd == 'closed') {
      this.lightBoxRef.close();
    }
    if (this.modalRef !== undefined) {
      this.modalRef.hide();
    }
  }
  canDeactivate() {
    return this.isModalOpen;
  }
  //Desc page 
  getIndex(i) {
    if (this.getnightclub !== undefined)
      if (this.getnightclub[this.mIndex] !== undefined) {
        this.mIndex = i;
        this.descCurrentnodeId = this.getnightclub[this.mIndex].nid;
        this.locationService.getIndex(this.descCurrentnodeId);
      }
  }
  unlhome = [];
  getmenu = [];
  goDescPage(mIndex, cIndex, item) {
    // this.unlServiceService.getTitle(item);
    // if (this.rmdetailsarray.length == 0) {
    //   this.locationService.getIndex(this.nodeId);
    // }
    // this.getrightmenuitem();
  }
  unlhome1 = [];
  //videos homepage link
  getnightvideos() {
    this.unlhome = [];
    let i = 8;
    var menus = this.unlServiceService.menus[i];
    var url, title;
    url =
      this.unlServiceService.menus[i].tabs[0].url +
      this.unlServiceService.image_preset;
    title = this.unlServiceService.menus[i].title;
    if (!url.includes("cit=")) {
      url = this.unlServiceService.updateURLParameter(url, "cit", this.unlServiceService.getTermId());
    } else {
      url = this.unlServiceService.updateURLParameter(url, "cit", this.unlServiceService.getTermId());
    }
    this.unlhome.push({ url, title });
  }
  //All page link
  getnight() {
    this.unlhome = [];
    this.unlhome1 = [];
    //  alert(this.unlhome1.length);
    let i = 0;
    for (i = 0; i < this.unlServiceService.menus.length; i++) {
      var menus = this.unlServiceService.menus[i];
      var url, title;
      if (i < 10) {
        url =
          this.unlServiceService.menus[i].tabs[0].url +
          this.unlServiceService.image_preset;
        title = this.unlServiceService.menus[i].title;
      } else if (i < 12 && i >= 10) {
        url =
          this.unlServiceService.menus[i].tabs[1].url +
          this.unlServiceService.image_preset;
        title = this.unlServiceService.menus[i].tabs[1].title;
      } else if (i === 12) {
        url =
          this.unlServiceService.menus[i].tabs[3].url +
          this.unlServiceService.image_preset;
        title = this.unlServiceService.menus[i].tabs[3].title
      } else {
        url =
          this.unlServiceService.menus[i].tabs[0].url +
          this.unlServiceService.image_preset;
        title = this.unlServiceService.menus[i].tabs[0].title
      }
      if (!url.includes("cit=")) {
        url = this.unlServiceService.updateURLParameter(url, "cit", this.unlServiceService.getTermId());
      } else {
        url = this.unlServiceService.updateURLParameter(url, "cit", this.unlServiceService.getTermId());
      }
      this.unlhome1.push({ url, title });
    }
    this.unlhome = this.unlServiceService.indexL.filter((i) => this.unlhome1[i]).map(i => this.unlhome1[i]);
    this.unlhome = this.unlhome.slice(0, 13);
  }
  getn() {
    this.getnight();
    if(environment.environmentType !== 'd') {
       this.getnightvideos();
    }
    this.getmenu = [];

    this.gettrendingnews();
    // this.unlServiceService.setMenuIndex();
    this.getdatarecursive(0);
  }
  //All page content
  getdatarecursive(count) {
    for (let count = 0; count < 13; count++) {
      this.getDataForHome(count);
    }
  }
  

  getDataForHome(count) {
    if (this.unlhome[count] !== undefined) {
      this.getmenu.push({
        title: this.unlhome[count].title,
        val: [],
      });
  
      this.http.get(this.unlhome[count].url).subscribe(
        (val) => {
          this.getnightclub = val;
          this.getmenu[count]["val"] = (count == 8) ? [] : val;
          this.rmdetailsarray = [...this.getmenu];
        },
        (error) => {
          console.error("Error fetching data:", error);
        }
      );
    }
  }
  
  /*getdatarecursive(count) {
    if (count < 13) {
      var httparr=[];
      for(var i=count;i<this.unlhome.length;i++){
          httparr.push(this.http.get(this.unlhome[i].url).pipe(tap( 
            res => this.rendervidphotoad(res) // updated for NightlifeTelevision site
            //res => console.log(res)
          )));
      }
      forkJoin(httparr).subscribe(results=>{
        for(var val in results){
          this.getmenu.push({
            val: results[val],
            title: this.unlhome[val].title
          });
        }
      });
      /*this.http.get(this.unlhome[count].url).subscribe(
        val => {
          this.getnightclub = val;
          this.getmenu.push({
            val: val,
            title: this.unlhome[count].title
          });
          this.getdatarecursive(++count);
        },
        error => { }
      );
    }
  }*/
  setPath() {
    this.description = this.locationService.setDescPath();
  }
  removeHtmlTag(html: string) {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  }
  firsturl(url: string) {
    return url.split(",", 1);
  }
  isimage(url: string) {
    return url.match(/\.(jpeg|jpg|gif|png)$/);
  }
  openLightbox(imageSlider, isVideo: Boolean) {
    LightboxModule.withConfig({
      panelClass: 'fullscreen'
    })
    if (isVideo) {
      this.items = imageSlider.map(item =>
        new VideoItem({ src: item.src })
      );
      this.gallery.ref('lightbox', {
        imageSize: ImageSize.Contain,
        nav: false,
        counterPosition: CounterPosition.Bottom,
        thumb: false,
        loop: false,
        loadingStrategy: LoadingStrategy.Preload,
        itemTemplate: this.lightbox,
        thumbTemplate: this.Lightboxtitle,
        loadingMode: 'indeterminate',
        panSensitivity: 100,

      }).load(this.items);
      this.lightBoxRef.open(0);
    } else {
      this.items = imageSlider.map(item =>
        new ImageItem({ src: item.srcUrl, thumb: item.previewUrl })
      );
      this.gallery.ref('lightbox', {
        imageSize: ImageSize.Contain,
        nav: false,
        counterPosition: CounterPosition.Bottom,
        thumb: false,
        loop: false,
        loadingStrategy: LoadingStrategy.Preload,
        itemTemplate: this.lightbox,
        thumbTemplate: this.Lightboxtitle,
        loadingMode: 'indeterminate',
        panSensitivity: 1000,
        gestures: true
      }).load(this.items);
      this.lightBoxRef.open(0);
    }

  }
  photourl(item) {
    var currlink = window.location.pathname.substring(1);
    if (window.location.href.indexOf("photoalbum") <= -1) {
      this.location2.go(currlink + '/photoalbum/' + item.nid + '/' + this.urltext(item.title));
    }
  }
  photoclose() {
    if (window.location.href.indexOf("photoalbum") > -1) {
      var currlink = window.location.pathname.split('/photoalbum/')[0];
      currlink = currlink.substring(1);
      this.router.navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate([currlink]));
      //this.location2.go(currlink);
    }
  }
  searchSlideshow(cObj) {
    this.albumsLightbox = [];
    var cArr = cObj.image_cache_photo.split(",");
    this.modalImgtitle = cObj.title;
    var nid = cObj.nid;
    this.nativeShareData.text = cObj.title;
    this.nativeShareData.url = this.unlServiceService.basepath + cObj.path.replace(/^\//g, '');
    jQuery.fancybox.defaults.hash = '/' + this.urltext(cObj.title) + '/' + nid;
    for (var i in cArr) {
      if (cArr[i].includes('service_tabs1')) {
        var imgSrc = cArr[i].replace("service_tabs1", "service_tabs2");
        var srcimg = cArr[i].replace("service_tabs1", "photo_600x380");
      } else if (cArr[i].includes('service_mobile1')) {
        var imgSrc = cArr[i].replace("service_mobile1", "service_tabs2");
        var srcimg = cArr[i].replace("service_mobile1", "photo_600x380");
      } else if (cArr[i].includes('service_default')) {
        var imgSrc = cArr[i].replace("service_default", "service_tabs2");
        var srcimg = cArr[i].replace("service_default", "photo_600x380");
      }
      const album = {
        src: srcimg,
        preview: imgSrc,
        description: cObj.title
      };
      this.albumsLightbox.push(album);
    }
    jQuery.fancybox.open(this.albumsLightbox);
    $("#fancy-div").append(this.modalImgtitle);
  }
  openSlideshow(mIndex: number, cIndex) {
    this.albumsLightbox = [];
    if (isNaN(cIndex)) {
      var cObj: any = cIndex;
      var cArr = cObj.image_album_path.full;
    } else {
      var cObj: any = this.getmenu[mIndex].val[cIndex];
      var cArr = cObj.image_cache.split(",");
    }
    //this.photourl(cObj);
    this.modalImgtitle = cObj.title;
    var nid = cObj.nid;
    this.nativeShareData.text = cObj.title;
    this.nativeShareData.url = this.unlServiceService.basepath + cObj.path.replace(/^\//g, '');
    jQuery.fancybox.defaults.hash = '/' + this.urltext(cObj.title) + '/' + nid;
    for (var i in cArr) {
      if (cArr[i].includes('service_tabs1')) {
        var imgSrc = cArr[i].replace("service_tabs1", "service_tabs2");
        var srcimg = cArr[i].replace("service_tabs1", "photo_600x380");
      } else if (cArr[i].includes('service_mobile1')) {
        var imgSrc = cArr[i].replace("service_mobile1", "service_tabs2");
        var srcimg = cArr[i].replace("service_mobile1", "photo_600x380");
      } else if (cArr[i].includes('service_default')) {
        var imgSrc = cArr[i].replace("service_default", "service_tabs2");
        var srcimg = cArr[i].replace("service_default", "photo_600x380");
      }
      const album = {
        src: srcimg,
        preview: imgSrc,
        description: cObj.title
      };
      this.albumsLightbox.push(album);
    }
    jQuery.fancybox.open(this.albumsLightbox);
    $("#fancy-div").append(this.modalImgtitle);
    var self = this;
    jQuery("#fancyclose").click(function () {
      //self.photoclose();
      jQuery.fancybox.close();
    });
  }
  openSlideshow1(cIndex) {
    console.log('okkkkkkk');
    this.albumsLightbox = []; // Clear albumsLightbox array
    this.modalImgindex = 0; // Reset modalImgindex
    
    // Extract necessary properties from cIndex object
    const cObj = cIndex;
    const cArr = cObj.image_cache.split(",");
  
    // Set modal image title and share data
    this.modalImgtitle = cObj.title;
    const nid = cObj.nid;
    this.nativeShareData.text = cObj.title;
    this.nativeShareData.url = this.unlServiceService.basepath + cObj.path.replace(/^\//g, '');
    
    // Check if Fancybox is properly loaded
    if (typeof jQuery.fancybox === 'undefined') {
      console.error('Fancybox is not loaded');
      return;
    }
  
    // Adjust fancybox hash based on title and nid
    jQuery.fancybox.defaults.hash = '/' + this.urltext(cObj.title) + '/' + nid;
    
    // Loop through each image path in cArr
    for (const imagePath of cArr) {
      let imgSrc, srcimg;
  
      // Modify paths based on conditions (if needed)
      if (imagePath.includes('service_tabs1')) {
        imgSrc = imagePath.replace("service_tabs1", "service_tabs2");
        srcimg = imagePath.replace("service_tabs1", "photo_600x380");
      } else if (imagePath.includes('service_mobile1')) {
        imgSrc = imagePath.replace("service_mobile1", "service_tabs2");
        srcimg = imagePath.replace("service_mobile1", "photo_600x380");
      } else if (imagePath.includes('service_default')) {
        imgSrc = imagePath.replace("service_default", "service_tabs2");
        srcimg = imagePath.replace("service_default", "photo_600x380");
      } else {
        // Default case if no modification is needed
        imgSrc = imagePath;
        srcimg = imagePath;
      }
  
      // Create album object and push to albumsLightbox array
      const album = {
        src: srcimg,
        preview: imgSrc,
        description: cObj.title
      };
      this.albumsLightbox.push(album);
    }
  
    // Open fancybox with albumsLightbox array
    jQuery.fancybox.open(this.albumsLightbox);
    
    // Append modal image title to fancy-div
    jQuery("#fancy-div").append(this.modalImgtitle);
  }
  
  ngAfterViewInit() {
    this.getScreenSize();
    var self = this;
    if (localStorage.scrollPosition) {
      this.scrollp = localStorage.getItem("scrollPosition")
      $(".ng-sidebar__content").scrollTop(this.scrollp);
      localStorage.removeItem('scrollPosition');
    }

    jQuery(document).ready(function () { //Photos Gallery   
      jQuery.fancybox.defaults.arrows = false;
      jQuery.fancybox.defaults.buttons = ['sharebtn', 'slideShow', 'close'];
      jQuery.fancybox.defaults.idleTime = 1000;
      jQuery.fancybox.defaults.infobar = true;
      jQuery.fancybox.defaults.btnTpl.sharebtn = '<button data-fancybox-sharebtn class="share-bttn photoshare"><i class="fas fa-share-alt"></i>Share</button>';
      jQuery.fancybox.defaults.baseTpl = '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-inner">' +
        '<div class="cssd1 container-fluid"><div class="fancybox-infobar infbar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span> <span class="fancybox-div" id="fancy-div"></span></div>' +
        '' +
        '<div class="fancybox-toolbar">{{buttons}}</div>' +
        '<div class="fancybox-navigation">{{arrows}}</div></div>' +
        '<div class="fancybox-stage"></div>' +
        "</div>" +
        "</div>";
      jQuery('body').on('click', '[data-fancybox-sharebtn]', function () {
        self.nativeShare();
      });
      // Custom options
      jQuery('[data-fancybox="images"]').fancybox({
        buttons: [
          'sharebtn', 'slideShow', 'close'
        ],
        idleTime: 1000,
        infobar: false,
        protect: true,
        fullScreen: {
          autoStart: true
        }
      });
    });
    jQuery(".fancybox").fancybox({
      openEffect: "elastic",
      closeEffect: "elastic",
      maxWidth: "100%",
    });
  }
  openVideoPlayer(mIndex: number, cIndex, item) {
  
    this.albumsLightbox = [];
    var cObj = this.getmenu[mIndex].val[cIndex];
    //this.videourl(item);
    if (item.type == 'videos live') {
      this.cArr = item.live_url;
      this.vidCatname = 'Live';
    } else {
      this.cArr = this.unlServiceService.basepath + cObj.converted_videos.sd_mp4;
    }
    this.Vtitle = cObj.title;
    // this.openModal(this.videoTemplate, false, true);
    const vpD = {
      crr: this.cArr,
      title: this.Vtitle,
      text: this.Vtitle,
      vidCatname: this.vidCatname,
      url: this.unlServiceService.basepath + item.path.replace(/^\//g, ''),
      description: this.nativeShareData.desc,
      platform: 'all'
    }
    this.unlServiceService.getvideodetails(vpD);
    this.unlServiceService.updateVideo(vpD);
    return this.cArr;
  }

  searchVideoPlayer(item) {
    this.Vtitle = item.title;
    console.log(item);
    this.videourl(item);
    if (item.type === 'Video') {
      var s = item.upload_video;
      this.vidCatname = 'Video';
      this.cArr = this.unlServiceService.basepath + s.substring(0, s.lastIndexOf(".")).replace('original', 'converted') + "_sd.mp4";
      const vidlink = {
        crr: this.cArr,
        title: this.Vtitle,
        vidCatname: this.vidCatname,
        text: this.Vtitle,
        url: this.unlServiceService.basepath + item.path.replace(/^\//g, ''),
        description: this.nativeShareData.desc,
        platform: 'all'
      }
      this.unlServiceService.updateVideo(vidlink);
      
      this.openModal(this.videoTemplate, false, true);
      return this.cArr;
    } else if (item.type === 'videos live') {
      this.vidCatname = 'Live';
      this.cArr = item.live_url;
      const vidlink = {
        crr: this.cArr,
        title: this.Vtitle,
        vidCatname: this.vidCatname
      }
      this.unlServiceService.updateVideo(vidlink);
      this.openModal(this.videoTemplate, false, true);
      return this.cArr;
    }
  }
  videourl(item) {
    var currlink = window.location.pathname.substring(1);
    if (window.location.href.indexOf("play") <= -1) {
      this.location2.go('/play/' + item.nid + '/' + this.urltext(item.title));
    }
  }
  videoPlayer(item) {
    this.Vtitle = item.title;
    this.videourl(item);
    this.nativeShareData.text = item.title;
    if (item.teaser != '' && item.teaser != undefined)
      this.nativeShareData.desc = item.teaser.substring(0, 95) + '...';
    else
      this.nativeShareData.desc = '';
    this.nativeShareData.url = this.unlServiceService.basepath + item.path.replace(/^\//g, '');//window.location.href.replace(window.location.origin+'/', this.unlServiceService.basepath);
    this.title.setTitle(item.title);
    this.meta.updateTag({ name: 'title', content: item.title });
    this.meta.updateTag({ property: 'og:title', content: item.title });
    this.meta.updateTag({ name: 'twitter:title', content: item.title });
    this.meta.updateTag({ name: 'description', content: this.nativeShareData.desc });
    this.meta.updateTag({ property: 'og:description', content: this.nativeShareData.desc });
    this.meta.updateTag({ name: 'twitter:description', content: this.nativeShareData.desc });
    this.meta.updateTag({ property: 'og:url', content: this.nativeShareData.url });
    this.meta.updateTag({ name: 'twitter:url', content: this.nativeShareData.url });
    if (item.converted_videos !== null) {
      this.cArr = this.unlServiceService.basepath + item.converted_videos.sd_mp4;
      this.vidCatname = 'Video';
    } else {
      this.cArr = item.live_url;
      this.vidCatname = 'Live';
    }
    this.openModal(this.videoTemplate, false, true);
    const vidlink = {
      crr: this.cArr,
      title: this.Vtitle,
      text: this.Vtitle,
      vidCatname: this.vidCatname,
      url:  this.nativeShareData.url,
      description: this.nativeShareData.desc,
      platform: 'all'
    }
    this.unlServiceService.updateVideo(vidlink);
    this.unlServiceService.getvideodetails(vidlink);
    return this.cArr;
  }
  setAutoplay(isMuted: boolean) {
    /*var vid = <HTMLVideoElement>document.getElementById("videoautoplay");
    if (isMuted) {
      vid.muted = false;
    } else {
      vid.muted = true;
    }*/
  }
  openSnackBar(isType: boolean) {
    if (isType) {
      console.log("opp", this.snackBar.open);

      this.snackBar.open("No More Content", '', {
        duration: 1500,
      });
    } else {
      this.snackBar.open("Enter and Search", '', {
        verticalPosition: "top", duration: 1500
      });
    }
  }

  openVideoPlayer1(cIndex, party) {
 
    if (party.type === 'Video') {
      this.albumsLightbox = [];
      var cObj = party;
      if (party.converted_videos.sd_mp4 == null) {
        const vidlink = {
          crr: this.unlServiceService.basepath + party.converted_videos.hd_mp4,
          title: party.title,
          vidCatname: this.vidCatname,
          vidpath: this.unlServiceService.basepath + party.path.replace(/^\//g, '')
        }
        //this.unlServiceService.getvideodetails(vidlink);
      }
      // this.cArr = this.unlServiceService.basepath + this.searchJson[cIndex].upload_video;
      // this.Vtitle = this.searchJson[cIndex].title;
      else {
        const vidlink = {
          crr: this.unlServiceService.basepath + party.converted_videos.sd_mp4,
          title: party.title,
          vidCatname: this.vidCatname,
          vidpath: this.unlServiceService.basepath + party.path.replace(/^\//g, '')
        }
        this.unlServiceService.getvideodetails(vidlink);
      }
      // this.albumsLightbox.push(vidlink);
      // this.openModal(this.videoTemplate, false, true);
      // this.openLightbox(this.albumsLightbox,true);
      return this.cArr;
    } else {
      this.albumsLightbox = [];
      var cObj = party;
      if (party.converted_videos !== null) {
        this.cArr = this.unlServiceService.basepath + party.converted_videos.sd_mp4;
      } else {
        this.cArr = party.live_url;
      }
      this.Vtitle = cObj.title;
      if (party.type == "videos live") {
        this.vidCatname = 'Live';
      }
      const vidlink = {
        crr: this.cArr,
        title: this.Vtitle,
        vidCatname: this.vidCatname,
        vidpath: this.unlServiceService.basepath + party.path.replace(/^\//g, '')
      }
      // this.albumsLightbox.push(vidlink);
      // this.openModal(this.videoTemplate, false, true);
      this.unlServiceService.getvideodetails(vidlink)
      // this.openLightbox(this.albumsLightbox,true);
      return this.cArr;
    }
  }
  //Ad
  getAD() {
    var adlen = this.item.tabs.length;
    if (this.rmi === 0) {
      adlen = this.unlServiceService.menus.length;
    }
    //this.unlServiceService.getAD(this.item,this.rmi,this);
    var ads = this.unlAdsService.getAds(adlen, adlen);
    ads.subscribe(responseData => {

      var ads = responseData;

    }, err => console.error('Observer got an error: ' + err),
      () => console.log('Observer got a complete notification'));
    /*this.adUrl =
      "https://papi.mynativeplatform.com/pub2/web/apiwidget.json?widget_key=vhWFtinM0GtBqXMtmXjq2f&url=http://nightlife.net/&paid_items=" + adlen + "&organic_items=" + adlen + "&organic_backfill=true&secure=true&zone&CB=";*/
    /* this.adUrl="./assets/json/advads.json";
   this.http.get(this.adUrl).subscribe(adJson => {
     this.adJson = adJson;
     for (var i = 0; i < this.adJson.items.length; i++) {

       this.adJsonContent.push(this.adJson.items[i].data.content);
       this.adJsonContent[i].impression_pixels = this.adJson.items[i].data.impression_pixels[0];
       this.adRedirect.push(this.adJson.items[i].data.action);
     }
     this.adJsonLenth = this.adJsonContent.length;
   });*/
  }

  switchPhototabs(currentab){
    this.currentvp=currentab;
    this.isLoading= true;
      if(currentab == 0){
        this.phototabs.recent=true;
        this.phototabs.mostviewed=false;
        
      }else{
        this.phototabs.recent=false;
        this.phototabs.mostviewed=true;
        
      } 
      this.isLoading = false;
      console.log("switch",this.isLoading)
      const cont_2 = this.el.nativeElement.querySelector('.contentclass');
      console.log("zoo",cont_2)
      if (cont_2) {
        cont_2.scrollTop = 0
      }
  }

  switchVideotabs(currentab){
    this.currentvp=currentab;
    this.isLoading= true;
      if(currentab == 0){
        this.videotabs.recent=true;
        
        this.videotabs.mostviewed=false;
        
      }else{
        this.videotabs.recent=false;
       
        this.videotabs.mostviewed=true;
        
      }
      this.isLoading= false;
      const cont_2 = this.el.nativeElement.querySelector('.contentclass');
      console.log("zoo",cont_2)
      if (cont_2) {
        cont_2.scrollTop = 0
      }
  }


  getitembymenuid(cData, mIndex) {
    if (this.rmi === 8 || this.rmi === 9) {
      this.vp=0;
      this.getVideosPhotos(this.rmi, mIndex, true);

    } else {
      var dataObj = {
        nocontent: false,
        mIndex: mIndex,
        newsLoading: true,
        viewLoading: true,
        val: undefined,
        title: cData.title
      }
      this.loadingarr$["newsLoading_" + mIndex] = true;
      if (!cData.title.includes("More")) {
        this.getrmdetailsarray.push(dataObj);
      } else {
        //this.moreDetailsArray = [];
        this.moreDetailsArray.push(dataObj);
        // this.unlServiceService.getMorecontent(this.moreDetailsArray);
      }
      
      console.log("cData.url:", cData.url);
      console.log("this.unlServiceService.image_preset:", this.unlServiceService.image_preset);
      var cDataUrl = cData.url;
      cDataUrl = this.unlServiceService.updateURLParameter(cDataUrl, "img_preset", this.unlServiceService.img_preset);
      this.http.get<any>(cDataUrl).subscribe(
        (val) => {
          // await Promise.all([promise, new Promise(resolve => setTimeout(resolve, 500))]);
    


          // const val = promise.then(val => {
          //   this.loadingarr["newsLoading_" + mIndex] = false;
          // });
          this.getrmdetails = val;
          if (!cData.title.includes("More")) {
            //this.getrmdetailsarray.push({ val: val || [], title: cData.title, nocontent: ((val != undefined) ? true : false) });
            this.getrmdetailsarray[mIndex].val = ((val.length == 0) ? [] : val);
            this.getrmdetailsarray[mIndex].nocontent = ((val.length == 0) ? true : false);
            this.getrmdetailsarray[mIndex].newsLoading = false;
            // this.loadingarr["newsLoading_"+mIndex]=((valtype != undefined) ? false : true);
          } else {
            // this.moreDetailsArray = [];
            // this.moreDetailsArray.push({ val: val || [], title: cData.title, nocontent: ((val != undefined) ? true : false) });
            if (this.moreDetailsArray[mIndex] !== undefined) {
              this.moreDetailsArray[mIndex].val = ((val.length == 0) ? [] : val);
              this.moreDetailsArray[mIndex].nocontent = ((val.length == 0) ? true : false);
              this.moreDetailsArray[mIndex].newsLoading = false;
              this.unlServiceService.getMorecontent(this.moreDetailsArray);
              // this.loadingarr["newsLoading_"+mIndex]=((valtype != undefined) ? false : true);
            }
          }

          this.loadingarr$["newsLoading_" + mIndex] = false;
          // for(var i=0;i<20;i++){
          //   this.loadingarr$["newsLoading_" + i] = false;
          // }
          this.newsLoading = false;
          this.viewLoading = false;
        },
        (err) => console.error(err),
        () => {
          
          this.changemenuarray();
        });
    }
  }
  ngDoCheck() {
    for(var i in this.getrmdetailsarray){
      if(!this.getrmdetailsarray[i].val !== undefined){
        var mIndex= this.rmdetailsarray[i] && this.rmdetailsarray[i].mIndex;
        //this.loadingarr$["newsLoading_" + mIndex] = false;
      }
    }
  }
  getrightmenuitem() {
    //this.moreDetailsArray = [];

    if (this.item !== undefined) {
      const cData = this.item.tabs[this.loadMenurIndex];
      if (cData !== undefined) {
        // debugger
        if (cData.title.toLowerCase() === 'comingsSoon - movies') {
          // alert("Coming Soon - Movies");
        }
        if (!cData.url.includes("cit=")) {
          cData.url = this.unlServiceService.updateURLParameter(cData.url, "cit", this.unlServiceService.getTermId());
        } else {
          cData.url = this.unlServiceService.updateURLParameter(cData.url, "cit", this.unlServiceService.getTermId());
        }
        this.newsLoading = true;
        this.viewLoading = true;

        try {
          if (((this.rmi == 8 || this.rmi == 9) && this.loadMenurIndex < 2) || (this.rmi != 8 && this.rmi != 9)){
            
      // alert(this.loadMenurIndex);
            this.getitembymenuid(cData, this.loadMenurIndex);

            this.loadMenurIndex++;
            this.getrightmenuitem();
          }
          //this.changemenuarray();
        } catch (_) {
          this.newsLoading = true;
          this.loadMenurIndex++;
          // alert("catch");
          this.getrightmenuitem();
        }

      } else {
        this.loadMenurIndex = 0;
      }
    }
  }

  changemenuarray() {
    if (this.rmi === 0 || this.rmi === undefined) {
      this.rmdetailsarray = this.getmenu;
    } else {
      this.rmdetailsarray = this.getrmdetailsarray;
    }
  }
  private _toggleSidebar() {
    this._opened = !this._opened;
  }
  checkvidephotossametab(vp) {
    var fetch = true;
    if (this.currentvp !== undefined) {
      if (this.currentvp == vp)
        return false;
    }
    return true;
  }
  getVideosPhotos(rmi, vp: number, execfunc) {
    //alert(vp);
    //var fetch=this.checkvidephotossametab(vp);
    this.currentLayout = 'normal';
    if (!execfunc)
      this.getcurrentvp(vp);
    else
      this.vp=0;

    if (rmi === 8 || rmi === 9) {
      //if (fetch && (rmi === 8 || rmi === 9)) {
      this.getcurrentvp(vp);
      this.detailsArrayIndex = 2;
      this.vparray = [];
      this.vpcontent = [];
      this.videosandphotos = [];
      // console.log(`the user is reaching the top`);
      // const cont_2 = this.el.nativeElement.querySelector('.contentclass');
      // console.log("zoo",cont_2)
      // if (cont_2) {
      //   cont_2.scrollTop = 0
      // }
      for (var i = 0; i < this.unlServiceService.menus[rmi].tabs.length; i++) {
        if (this.unlServiceService.menus[rmi].tabs[i]['isinindex'] != undefined)
          continue;
        this.videosandphotos.push(this.unlServiceService.menus[rmi].tabs[i]);
      }
      //this.videosandphotos = this.unlServiceService.menus[rmi].tabs;
      //var path = window.location.pathname.split('/');
      //if(this.videosandphotos.length==3 && (path[2]=="videos" && !path[4] || path[4]=="category") && (path[2]=="phhotos" && !path[4] || path[4]=="category"))
      //this.videosandphotos.pop();
      if (this.vidTermId)
        var catgurl = this.unlServiceService.menus[rmi].tabs[vp].url.replace('args[0]=all', 'args[0]=' + this.vidTermId);
      else
        var catgurl = this.unlServiceService.menus[rmi].tabs[vp].url;
      catgurl = this.unlServiceService.updateURLParameter(catgurl, "cit", this.unlServiceService.getTermId());
      this.isLoading = true;
      this.http
        .get(catgurl)
        .subscribe((val: any[]) => {
          for (let i = 0; i < Object.keys(val).length; i++) {
            if (val[i].type == 'videos live' && val[i].image_cache.split('service_mobile1/')[1] == '') {
              val[i].image_cache = val[i].image_cache + val[i].live_video_thumb.split('files/')[1];
            }
          }
          this.vparray.push({
            val: val,
            title: this.unlServiceService.menus[rmi].tabs[vp].title
          });

          if (execfunc) {
            this.getcurrentvp(0);
          }
          var vpval = vp;
          this.getrmdetails = val;
          if(this.rmi == 9 && vpval == 0){
            for(let k of val){
              this.photocontentrecent.push(k);
            }
            this.photocontentrecent.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.photocontentrecent.splice(index, 1);
            });
            this.rendervidphotoad(this.photocontentrecent);
          }
          else if(this.rmi == 9 && vpval != 0){
            for(let k of val){
              this.photocontentmost.push(k);
            }
            this.photocontentmost.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.photocontentmost.splice(index, 1);
            });
            this.rendervidphotoad(this.photocontentmost);
          }else if(this.rmi == 8 && vpval == 0){
            for(let k of val){
              this.videocontentrecent.push(k);
            }
            this.videocontentrecent.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.videocontentrecent.splice(index, 1);
            });
            this.rendervidphotoad(this.videocontentrecent);
          }
          else if(this.rmi == 8 && vpval != 0){
            for(let k of val){
              this.videocontentmost.push(k);
            }
            this.videocontentmost.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.videocontentmost.splice(index, 1);
            });
            this.rendervidphotoad(this.videocontentmost);
          }
          this.vpcontent = this.vparray[0].val;
          this.vpcontent.forEach((element, index) => {
            if (element.type != undefined && element.type == 'ad') this.vpcontent.splice(index, 1);
          });
          
          this.isLoading = false;
        });

    }
  }
  getVideosPhotos1(rmi, vp: number, execfunc) {
    //alert(vp);
    //var fetch=this.checkvidephotossametab(vp);
    this.currentLayout = 'normal';
    if (!execfunc)
      this.getcurrentvp(vp);



    if (rmi === 8 || rmi === 9) {
      //if (fetch && (rmi === 8 || rmi === 9)) {
      this.getcurrentvp(vp);
      this.detailsArrayIndex = 2;
      this.vparray = [];
      this.vpcontent = [];
      this.videosandphotos = [];
      // console.log(`the user is reaching the top`);
      // const cont_2 = this.el.nativeElement.querySelector('.contentclass');
      // console.log("zoo2",cont_2)
      // if (cont_2) {
      //   cont_2.scrollTop = 0
      // }
      for (var i = 0; i < this.unlServiceService.menus[rmi].tabs.length; i++) {
        if (this.unlServiceService.menus[rmi].tabs[i]['isinindex'] != undefined)
          continue;
        this.videosandphotos.push(this.unlServiceService.menus[rmi].tabs[i]);
      }
      //this.videosandphotos = this.unlServiceService.menus[rmi].tabs;
      //var path = window.location.pathname.split('/');
      //if(this.videosandphotos.length==3 && (path[2]=="videos" && !path[4] || path[4]=="category") && (path[2]=="phhotos" && !path[4] || path[4]=="category"))
      //this.videosandphotos.pop();
      if (this.vidTermId)
        var catgurl = this.unlServiceService.menus[rmi].tabs[vp].url.replace('args[0]=all', 'args[0]=' + this.vidTermId);
      else
        var catgurl = this.unlServiceService.menus[rmi].tabs[vp].url;
      catgurl = this.unlServiceService.updateURLParameter(catgurl, "cit", this.unlServiceService.getTermId());
      this.isLoading = true;
      this.http
        .get(catgurl)
        .subscribe(val => {
          for (let i = 0; i < Object.keys(val).length; i++) {
            if (val[i].type == 'videos live' && val[i].image_cache.split('service_mobile1/')[1] == '') {
              val[i].image_cache = val[i].image_cache + val[i].live_video_thumb.split('files/')[1];
            }
          }
          this.vparray.push({
            val: val,
            title: this.unlServiceService.menus[rmi].tabs[vp].title
          });

          if (execfunc) {
            this.getcurrentvp(0);
          }
          var vpval = this.currentvp;
          this.getrmdetails = val;
          this.vpcontent = this.vparray[0].val;
          this.vpcontent.forEach((element, index) => {
            if (element.type != undefined && element.type == 'ad') this.vpcontent.splice(index, 1);
          });
          this.rendervidphotoad(this.vpcontent);
          this.isLoading = false;
        });

    }
  }









  rendervidphotoad(arrData) {
    let isFourth = false;
    var adSetIndex=0;
    var detailsArrayIndex=2;
     var vpval =this.currentvp
    if(this.rmi == 9 && vpval == 0){
      adSetIndex=this.adSetIndex_photosrecent;
      detailsArrayIndex=this.detailsArrayIndex_photosrecent;
    }else if(this.rmi == 9 && vpval != 0){
      adSetIndex=this.adSetIndex_photosmost;
      detailsArrayIndex=this.detailsArrayIndex_photosmost;
    }else if(this.rmi == 8 && this.currentvp == 0){
      adSetIndex=this.adSetIndex_videosrecent;
      detailsArrayIndex=this.detailsArrayIndex_videosrecent;
    }else if(this.rmi == 8 && vpval !=0){
      adSetIndex=this.adSetIndex_videosmost;
      detailsArrayIndex=this.detailsArrayIndex_videosmost;
    }else{
      detailsArrayIndex=this.detailsArrayIndex;
    }

    if(this.rmi == 9 && vpval == 0){
      this.adSetIndex_photosrecent=adSetIndex;
      this.detailsArrayIndex_photosrecent=detailsArrayIndex;
    }else if(this.rmi == 9 && vpval != 0){
      this.adSetIndex_photosmost=adSetIndex;
      this.detailsArrayIndex_photosmost=detailsArrayIndex;
    }else if(this.rmi == 8 && this.currentvp == 0){
      this.adSetIndex_videosrecent=adSetIndex;
      this.detailsArrayIndex_videosrecent=detailsArrayIndex;
    }else if(this.rmi == 8 && vpval !=0){
      this.adSetIndex_videosmost=adSetIndex;
      this.detailsArrayIndex_videosmost=detailsArrayIndex;
    }else{
      this.detailsArrayIndex=detailsArrayIndex;
    }
  }

  getcurrentvp(vp) {
    // this.pg = 1;
    // this.urlnum = 1; 
    this.currentvp = vp;

    // this.vp = vp;
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }
  termIdGenphto(i, vp) {
    this.vidTermId = this.photoCatList[i]["term id"];
    this.vidCatname = this.photoCatList[i].term;
    var city = this.unlServiceService.getTermId();
    this.openCatagory();
    this.router.navigate([this.pagetype + '/' + city + '/category/' + this.urltext(this.vidCatname) + '/' + this.vidTermId]);
    this.selectvps = this.vidCatname;
  }
  termIdGenvid(i, vp) {
    this.vidTermId = this.videoCatList[i]["term id"];
    this.vidCatname = this.videoCatList[i].term;
    var city = this.unlServiceService.getTermId();
    this.openCatagory();
    this.router.navigate([this.pagetype + '/' + city + '/category/' + this.urltext(this.vidCatname) + '/' + this.vidTermId]);
    this.selectvps = this.vidCatname;
  

  }
  urltext(text) {
    text = text.replace('&#039;', '').replace('&amp;', '').replace('&quot;', '').replace('quot;', '');
    text = text.replace(/[&\/\\#,+()$~%!‘’.'":;*?<>@{}-]/g, '');
    return text.replace(/\s+/g, '-').toLowerCase();
  }
  contentpage(node) {
    if (node.type) {
      var nodetype = this.urltext(node.type).toLowerCase();
    } else {
      var nodetype: any = 'all';
    }
    if (!node.title)
      var nodetitle = node.node_title;
    else
      var nodetitle = node.title;
    if (nodetype == 'video1' || nodetype == 'video' || nodetype == 'videos-live') {
      nodetype = 'videos';
    } else if (nodetype == 'event') {
      nodetype = 'parties-events';
    } else if (nodetype == 'concerts') {
      nodetype = 'concerts-shows';
    } else if (nodetype == 'hotel') {
      nodetype = 'hotels-resorts';
    }
    return '/' + nodetype + '/' + this.termid + '/' + node.nid + '/' + this.urltext(nodetitle);
  }
  homepagelink(title, node) {
    if (node.type == 'ad') {
      return window.location.pathname;
    }
    if (!node.title)
      var nodetitle = node.node_title;
    else
      var nodetitle = node.title;
    return '/' + this.urltext(title) + '/' + this.termid + '/' + node.nid + '/' + this.urltext(nodetitle);
  }
  catagories() {
    if (this.rmi == 8) {
      this.vidCatagories = this.unlServiceService.vidCatagories;
      this.http.get(this.vidCatagories).subscribe(videoCatList => {
        this.videoCatList = videoCatList;
        if (this.videoCatList[0].term !== 'All Videos') {
          this.videoCatList.splice(0, 0, { term: "All Videos", "term id": "all" });
        }
        this.selectvps = this.findObjectByKey(this.videoCatList, 'term id', this.vidTermId).term;
        $("#videocatname").html(this.selectvps);
      });
    }
    if (this.rmi == 9) {
      this.phtoCatagories = this.unlServiceService.phtoCatagories;
      this.http.get(this.phtoCatagories).subscribe(photoCatList => {
        this.photoCatList = photoCatList;
        if (this.photoCatList[0].term !== 'All Photos') {
          this.photoCatList.splice(0, 0, { term: "All Photos", "term id": "all" });
        }
        this.photoCatList[0]['term id'] = 'all';
        var catnameary = this.findObjectByKey(this.photoCatList, 'term id', this.vidTermId);
        if (catnameary !== null)
          this.selectvps = this.findObjectByKey(this.photoCatList, 'term id', this.vidTermId).term;
        else
          this.selectvps = 'All Photos';
        $("#videocatname").html(this.selectvps);
      });
    }
  }
  
  getVideosPhotosCat(rmi, vp) {
    //var fetch=this.checkvidephotossametab(vp);
    ///this.getcurrentvp(0);
    //if (fetch && rmi === 8) {


    if (rmi === 8 || rmi === 9) {
      this.detailsArrayIndex = 2;
      this.getcurrentvp(0);
      this.vparray = [];
      this.vpcontent = [];
    
      console.log("get",this.isLoading);
      if(rmi == 9 && vp == 0){
        this.pg_photosrecent = 1;
        this.photocontentrecent = [];
      }else if(rmi == 9 && vp == 1){
        this.pg_photosmost = 1;
        this.photocontentmost = [];
      }else if(rmi == 8 && vp == 0){
        this.pg_videosrecent = 1;
        this.videocontentrecent = [];
      }else if(rmi == 8 && vp == 1){
        this.pg_videosmost = 1;
        this.videocontentmost = [];
      }
      this.videosandphotos = [];
      
      for (var i = 0; i < this.unlServiceService.menus[rmi].tabs.length; i++) {
        if (this.unlServiceService.menus[rmi].tabs[i]['isinindex'] != undefined)
          continue;
        this.videosandphotos.push(this.unlServiceService.menus[rmi].tabs[i]);
      }
      var catgurl=this.unlServiceService.menus[rmi].tabs[vp].url;
      catgurl=this.unlServiceService.updateURLParameter(catgurl, "cit", this.unlServiceService.getTermId());
      catgurl=this.unlServiceService.updateURLParameter(catgurl, "args[0]", this.vidTermId);
      catgurl=this.unlServiceService.updateURLParameter(catgurl, "img_preset", "service_mobile1");
      
      this.isLoading = true;
      this.http
        .get(catgurl)
        .subscribe((val:any[]) => {
          this.getrmdetails = val;
          this.vparray.push({ val: val });
          var image_cache = this.vparray[0].image_cache;
          for (var i = 0; i < this.vparray[0].val.length; i++) {
            var imgche = this.vparray[0].val[i].image_cache;
            if (this.vparray[0].val[i].live_video_thumb != undefined) {
              var live_video_thumb = this.vparray[0].val[i].live_video_thumb.split("files/");
              if (!imgche.endsWith(".png") && !imgche.endsWith(".jpg")) {
                this.vparray[0].val[i].image_cache = imgche + live_video_thumb[1];
              } else {
                this.vparray[0].val[i].image_cache = imgche
              }
            } else {
              this.vparray[0].val[i].image_cache = imgche
            }
          }
          if(this.rmi == 9 && vp == 0){
            for(let k of val){
              this.photocontentrecent.push(k);
            }
            this.photocontentrecent.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.photocontentrecent.splice(index, 1);
            });
            this.rendervidphotoad(this.photocontentrecent);
          }
          else if(this.rmi == 9 && vp == 1){
            for(let k of val){
              this.photocontentmost.push(k);
            }
            this.photocontentmost.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.photocontentmost.splice(index, 1);
            });
            this.rendervidphotoad(this.photocontentmost);
          }else if(this.rmi == 8 && vp == 0){
            for(let k of val){
              this.videocontentrecent.push(k);
            }
            this.videocontentrecent.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.videocontentrecent.splice(index, 1);
            });
            this.rendervidphotoad(this.videocontentrecent);
          }
          else if(this.rmi == 8 && vp == 1){
            for(let k of val){
              this.videocontentmost.push(k);
            }
            this.videocontentmost.forEach((element, index) => {
              if (element.type != undefined && element.type == 'ad') this.videocontentmost.splice(index, 1);
            });
            this.rendervidphotoad(this.videocontentmost);
          }
         
          this.vpcontent = this.vparray[0].val;
          this.isLoading = false;
        });
       
    }    
  }




  openCatagory() {
    this.catagoryIdentifier = 0;
    var wH = $(window).height();
    var headerHeight = $("#fixedheader").outerHeight(true);
    var titleH = $(".fixedtitle").outerHeight(true);
    var innertiH = $(".topbarfix .col-7").outerHeight(true);
    var h = wH - (headerHeight + titleH + innertiH + 30);
    this.show = !this.show;
    setTimeout(function () {
      $(".catagories").height(h + "px");
    }, 0);
    this.switchPhototabs(0);
    this.switchVideotabs(0);
  }
  viewalllink(mIndex, title) {
      localStorage.setItem("scrollPosition",'0');
      window.scrollTo(0, 0);
      this.router.navigate([this.urltext(title) + '/' + this.termid + '/viewall/' + mIndex + '/' + this.rmi]);
  }
  viewallcontent(mIndex) {
    $(".ng-sidebar__content").scrollTop(0);
    var splitAry = window.location.pathname.split('/viewall/')[1].split('/');
    this.rmi = splitAry[1];
    this.searchvalue = '';
    this.viewallurlNumpc = 1;
    this.detailsArrayIndex = 2;
    this.urlnum = 1;
    this.pg = 1;
    this.viewallmindex = mIndex
    this.currentLayout = "vall";
    $("#searchtextclear").hide();
    this.getScreenSize();
    this.item = this.unlServiceService.menus[this.rmi];
    $(".aligner1 li").removeClass('active');
    $(".aligner1 li").eq(parseInt(this.rmi)).addClass('active');
    this.checkArray = this.item.tabs[mIndex];
    // this.checkArray.url = this.checkArray.url + '&img_preset=service_mobile1';
    this.checkArray.url = this.unlServiceService.updateURLParameter(this.checkArray.url, "img_preset", this.unlServiceService.img_preset);
    this.checkArray.url = this.unlServiceService.updateURLParameter(this.checkArray.url, "cit", this.unlServiceService.getTermId());
    this.viewLoading1 = true;
    this.http.get(this.checkArray.url).pipe(
      finalize(() => {
        this.viewLoading1 = false;
      }),
    ).subscribe(val => {
      for (let i = 0; i < Object.keys(val).length; i++) {
        //   if(val[i].concerts_date || val[i].event_date){
        //     val[i].image_cache = val[i].image_cache.replace('service_default','service_tabs1');
        //   }
        if (val[i].type == 'videos live' && val[i].image_cache.split('service_mobile1/')[1] == '') {
          val[i].image_cache = val[i].image_cache + val[i].live_video_thumb.split('files/')[1];
        }
      }
      $("#toptitle").html(this.item.title);
      var menutitle = this.locname + this.checkArray.title + ' | ' + this.unlServiceService.sitename;
      this.title.setTitle(menutitle);
      this.meta.updateTag({ name: 'title', content: menutitle });
      this.meta.updateTag({ property: 'og:title', content: menutitle });
      this.meta.updateTag({ name: 'twitter:title', content: menutitle });
      this.viewAllTitle = this.checkArray.title;
      // $("#pageloaderhome").hide();
      var viewalltab = val;
      if (viewalltab[0] !== undefined) {
        this.viewallpart = val;
        this.rendervidphotoad(val);
        this.tpc = viewalltab[0];
        this.vaIndex = mIndex;
        this.tpcp = this.tpc["total pages count"];
        if (this.tpcp == undefined) {
          this.tpcp = this.tpc['totalpagecount'];
        }
      }
      this.viewLoading = false;
    });
  }

  // viewAll(mIndex, i, title) {
  //   //this.router.navigate([this.urltext(title)+'/'+this.termid+'/viewall/'+mIndex+'/'+this.rmi]);
  //   // var splitAry = window.location.pathname.split('/viewall/')[1].split('/');
  //   // this.rmi=splitAry[1];
  //   this.getScreenSize();
  //   this.viewallurlNumpc = 1;
  //   this.urlnum = 1;
  //   this.pg = 1;
  //   this.viewallmindex = mIndex
  //   this.currentLayout = "vall";
  //   this.checkArray = this.unlServiceService.menus[this.rmi].tabs[mIndex];
  //   console.log(mIndex, this.rmi, this.checkArray);
  //   console.log(this.checkArray.hasOwnProperty("viewall"));
  //   // if (!this.checkArray.hasOwnProperty("viewall")) {
  //   //   console.log(this.getrmdetailsarray[mIndex]);
  //   //   this.viewallpart = this.rmdetailsarray[mIndex].val;
  //   //   this.vaIndex = mIndex;
  //   //   this.tpc = this.viewallpart[0];
  //   //   this.tpcp = this.tpc["total pages count"];
  //   //   this.viewAllTitle = title;

  //   // } else if (this.checkArray.hasOwnProperty("viewall")) {
  //     if (this.checkArray.viewall !== undefined) {
  //       if (!this.checkArray.viewall.includes("cit=")) {
  //         this.checkArray.viewall = this.unlServiceService.updateURLParameter(this.checkArray.viewall, "cit", this.unlServiceService.getTermId());
  //         //cData.url += "&cit=" + this.unlServiceService.getTermId();
  //       } else {
  //         this.checkArray.viewall = this.unlServiceService.updateURLParameter(this.checkArray.viewall, "cit", this.unlServiceService.getTermId());
  //         //cData.url = cData.url.replace("cit=", "cit=" + this.unlServiceService.getTermId());
  //       }
  //     }
  //     console.log(this.checkArray.viewall);
  //     this.http.get(this.checkArray.viewall).subscribe(val => {
  //       for(let i = 0; i < Object.keys(val).length; i++){
  //         if(val[i].concerts_date || val[i].event_date){
  //           val[i].image_cache = val[i].image_cache.replace('service_default','service_tabs1');
  //         }
  //       }
  //       console.log(val);
  //       var viewalltab = val;
  //       this.viewallpart = val;
  //       this.tpc = viewalltab[0];
  //       this.vaIndex = mIndex;
  //       this.tpcp = this.tpc["total pages count"];
  //       this.viewAllTitle = title;
  //     });
  //   //}
  // }
  handleScroll(event: ScrollEvent) {
    if (event.isReachingBottom) {
      console.log(`the user is reaching the bottom`);
      //this.scrollFn();
      var executed = false;
      if (!executed && this.pg < this.tpcp) {
        executed = true;
        var cData;
        var checkArray: any = this.unlServiceService.menus[this.rmi].tabs[this.viewallmindex];
        if (checkArray != undefined)
          if (checkArray.viewall == undefined) {
            cData = this.item.tabs[this.vaIndex].url;
            cData = this.unlServiceService.updateURLParameter(cData, "limit", "10");
            cData = this.unlServiceService.updateURLParameter(cData, "page", this.urlnum);
            if (!cData.includes("cit=")) {
              cData = this.unlServiceService.updateURLParameter(cData, "cit", this.unlServiceService.getTermId());
            } else {
              cData = this.unlServiceService.updateURLParameter(cData, "cit", this.unlServiceService.getTermId());
            }
          } else {
            var pageSet = "page=" + this.viewallurlNumpc;
            if (checkArray.viewall.indexOf("page=0") > -1)
              cData = checkArray.viewall.replace("page=0", pageSet);
            else
              cData = checkArray.viewall + '&' + pageSet;
            if (!cData.includes("cit=")) {
              cData = this.unlServiceService.updateURLParameter(cData, "cit", this.unlServiceService.getTermId());
            } else {
              cData = this.unlServiceService.updateURLParameter(cData, "cit", this.unlServiceService.getTermId());
            }
          }
        this.spinnerService.show();
        this.http.get(cData).subscribe(
          val => {
            this.viewallpart = this.viewallpart.concat(val);
            // if ((this.pg + 1) == this.tpcp) {
            //   this.openSnackBar(true);
            // }

            for (let i = 0; i < Object.keys(this.viewallpart).length; i++) {
              if (this.viewallpart[i].concerts_date || this.viewallpart[i].event_date) {
                this.viewallpart[i].image_cache = this.viewallpart[i].image_cache.replace('service_default', 'service_mobile1');
              }
            }
            this.rendervidphotoad(this.viewallpart);
            
            this.spinnerService.hide();

          },
          error => {
          });
        this.pg++;
        this.urlnum++;
        this.viewallurlNumpc++;
        executed = false;
        console.log(this.pg + " page loaded");
      } else {
        this.openSnackBar(true);
      }
    }
    // if (event.isReachingTop) {
    //   console.log(`the user is reaching the top`);
    // }
  }
  handleSearchScroll(event: ScrollEvent) {
    if (event.isReachingBottom) {
      var executedsrc = false;
      var totalpages = this.searchJson[0]["total pages count"];
      if (!executedsrc && this.searchpage < totalpages) {
        this.spinnerService.show()
        executedsrc = true;
        this.getScreenSize();
        var city = this.unlServiceService.getTermId();
        var sURL = this.unlServiceService.getSearchURL(this.searchvalue, this.radval, this.rmi, city, this.searchpage);
        this.http.get(sURL).subscribe(val => {
          for (let i = 0; i < Object.keys(val).length; i++) {
            if (val[i].type == 'videos live' && val[i].image_cache.split('service_mobile1/')[1] == '') {
              val[i].image_cache = val[i].image_cache + val[i].live_video_thumb.split('/')[3];
            }
          }
          this.searchJson = this.searchJson.concat(val);
          if (this.searchpage == totalpages && ($("#searchscroll").scrollTop() + $("#searchscroll").innerHeight() >= $("#searchscroll")[0].scrollHeight)) {
            this.openSnackBar(true);
          }
          this.rendervidphotoad(this.searchJson);
          this.spinnerService.hide();
        });
        this.searchpage++;
        executedsrc = false;
      }
    }
  }
  
  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    var wH = $(window).height();
    // var topbarfix = $(".widthfix").outerHeight(true);
    var headerHeight = $("#fixedheader").outerHeight(true);
    var titleH = $("#fixedtit").outerHeight(true);
    if (!titleH)
      titleH = 0;
    this.maTop = titleH;
    this.searchfix = headerHeight + titleH;
    var screenHeight = wH - this.searchfix;
    this.loaderH = screenHeight - 36;
    if (this.currentLayout == 'search') {
      this.searchScreenHeight = screenHeight - 36;
      this.screenHeight = 0;
      $(".searchcss form").addClass('open');
      setTimeout(function () { //in case search close mark is not added
        if ($(".searchcss form").hasClass('open') == false)
          $(".searchcss form").addClass('open');
      }, 1000);
    } else {
      this.screenHeight = screenHeight;
      this.searchScreenHeight = 0;
      $(".searchcss form").removeClass('open');
    }

  }
  closeSearch() {
    this.currentLayout = 'normal';
    this.getScreenSize();
    $("#toptitle").text(this.unlServiceService.menus[this.rmi].title);
    $("#searchtextclear").hide();
    this.searchvalue = '';
    this.searchkey = '';
    var city = this.unlServiceService.getTermId();
    this.router.navigate([this.pagetype + '/' + city]);
    this.updateSearch(this.searchvalue);
  }
  searchclear() {
    this.searchvalue = '';
    $("#searchtextclear").hide();
    this.updateSearch(this.searchvalue);
  }
  searchclearshow(searchvalue) {
    if (searchvalue != '') {
      $("#searchtextclear").show();
    } else {
      $("#searchtextclear").hide();
      this.searchvalue = '';
    }
    this.updateSearch(this.searchvalue);
  }
  ngAfterContentInit() {
    //this.getAD();
  }
  searchaction(radval, searchvalue) {
    if ($.trim(searchvalue) != '') {
      this.searchvalue = searchvalue;
      var city = this.unlServiceService.getTermId();
      this.pagetype = this.unlServiceService.menus[this.rmi].link;
      if (this.rmi !== 0) {
        if ((this.rmi == 8 || this.rmi == 9) && this.currentLayout !== 'search') {
          if (radval == 1) {
            this.pagetype = 'all';
            //this.router.navigate(['all/'+city+'/search/'+this.searchvalue]);
            this.searchTitle = this.unlServiceService.menus[this.rmi].title;
            this.searchredirect(radval);
          } else {
            //this.router.navigate([this.pagetype+'/'+city+'/search/'+this.searchvalue]);
            this.searchTitle = this.unlServiceService.menus[this.rmi].title;
            this.searchredirect(radval);
          }
        } else {
          if (this.pagetype != 'all') {
            this.searchTitle = this.unlServiceService.menus[this.rmi].title;
            this.openModal(this.searchtemp, true, false);
          } else {
            this.router.navigate(['all/' + city + '/search/' + this.searchvalue]);
          }
        }
      } else {
        this.router.navigate([this.pagetype + '/' + city + '/search/' + this.searchvalue]);
      }

    } else {
      alert('Please enter your search keyword');
    }
    this.pageLoading = false;
    this.newsLoading = false;
    this.viewLoading = false;
  }
  searchredirect(radval) {
    this.issearch1 = true;
    if(radval === 2) {
      this.issearch2 = true;
    }
    this.modalRef.hide();
    var city = this.unlServiceService.getTermId();
    if (radval == 1) {
      this.pagetype = 'all';
      //this.router.navigate(['all/'+city+'/search/'+this.searchvalue]);
      setTimeout(() => this.router.navigate(['all/' + city + '/search/' + this.searchvalue]), 1000);
    } else {
      //this.router.navigate([this.pagetype+'/'+city+'/search/'+this.searchvalue]);
      setTimeout(() => this.router.navigate([this.pagetype + '/' + city + '/search/' + this.searchvalue]), 1000);
    }
    this.pageLoading = false;
    this.newsLoading = false;
    this.viewLoading = false;
    this.updateSearch(this.searchvalue);
  }

  openSm(content, searchvalue, rmi) {
    this.searchclearshow(searchvalue);
    this.searchTitle = this.unlServiceService.menus[this.rmi].title;
    this.searchvalue = searchvalue;
    jQuery(".searchbar").blur();
    jQuery(".srchbtn").focus();
    this.getAD();
    this.detailsArrayIndex = 2;
    if (this.rmi !== 0) {
      if (this.searchvalue !== undefined) {
        if (rmi !== 0) {
          if (content == 'direct') {
            this.currentLayout = "search";
            this.getsearchjson(this.radval);
          }
        } else if (rmi == 0) {
          this.getsearchjson(this.radval);
        }
      } else {
        this.openSnackBar(false);
      }
    }
    // else if(this.pagetype != 'all'){
    //   this.getsearchjson(this.radval);
    // }
    else {
      this.getsearchjson(1);
    }
    setTimeout(function () { //in case search close mark is not added
      if (jQuery("#searchtextclear").css('display') == 'undefined' && this.searchvalue != '')
        jQuery("#searchtextclear").show();
    }, 1000);
    this.pageLoading = false;
    this.newsLoading = false;
    this.viewLoading = false;
  }
  openSm1(content, rmi) {
    this.getAD();
    this.detailsArrayIndex = 2;
    this.searchTitle = this.unlServiceService.menus[this.rmi].title;
    this.openModal(content, true, false);
  }
  getsearchjson(radval) {
    var city = this.unlServiceService.getTermId();
    jQuery("#scrollload").show();
    this.currentLayout = "search";
    this.radval = radval;
    this.searchpage = 0;
    var sURL = this.unlServiceService.getSearchURL(this.searchvalue, this.radval, this.rmi, city, this.searchpage);
    this.getScreenSize();
    this.http.get(sURL).subscribe(val => {
      for (let i = 0; i < Object.keys(val).length; i++) {
        if (val[i].type == 'videos live' && val[i].image_cache.split('service_mobile1/')[1] == '') {
          val[i].image_cache = val[i].image_cache + val[i].live_video_thumb.split('/')[3];
        }
      }
      this.rendervidphotoad(val);
      this.searchJson = val;
      var tt = $("#toptitle").text();
      if (this.radval == 1) {
        $("#toptitle").text('Search All');
      } else {
        $("#toptitle").text('Search ' + this.searchTitle);
      }
      jQuery("#scrollload").hide();
      setTimeout(function () { //in case search load is not closed 
        if (jQuery("#scrollload").css('display') == 'block')
          jQuery("#scrollload").hide();
      }, 3000);
    });
    this.searchpage++;
    this.pageLoading = false;
    this.newsLoading = false;
    this.viewLoading = false;
  }
  gettrendingnews() {
    this.pageLoading = true;
   
    this.http.get(`${this.unlServiceService.basepath}testunl/views/unl_service_news_page.json?limit=10&display_id=page_3&cit=${this.termid}&img_preset=service_mobile1`).subscribe(val => {
      //this.getAD();
      this.trendJson = val
      // console.log(this.trendJson);
      var last_element = this.trendJson.length;
      // console.log(last_element);

      // if (this.adJsonContent[7] !== undefined && this.trendJson[this.trendJson.length - 1]["type"] == undefined) {
      //   const Adarray = {
      //     body: this.adJsonContent[7].body,
      //     title: this.adJsonContent[7].title,
      //     image_cache: this.adJsonContent[7].image,
      //     type: "ad",
      //     redirect: this.adJsonContent[7].clickurl,
      //     impixels: this.adJsonContent[7].impixels
      //   };
      //   this.trendJson.splice(2, 0, Adarray);
      // }
      // if (this.adJsonContent[8] !== undefined && this.trendJson[this.trendJson.length - 1]["type"] == undefined) {
      //   const Adarray = {
      //     body: this.adJsonContent[8].body,
      //     title: this.adJsonContent[8].title,
      //     image_cache: this.adJsonContent[8].image,
      //     type: "ad",
      //     redirect: this.adJsonContent[8].clickurl,
      //     impixels: this.adJsonContent[8].impixels
      //   };
      //   this.trendJson.splice(6, 0, Adarray);
      // }
      // for (let i = 0; i < this.trendJson.length; i++) {
      //   if(this.trendJson[i].image_cache)
      //   this.trendJson[i].image_cache = this.trendJson[i].image_cache.replace('service_default','service_mobile1');
      // }
      this.pageLoading = false;
    });
  }
  imageChange(event) {
    this.modalImgindex = event.index;
  }
  public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
    // console.log("hello");
    // this.renderer.addClass(target, visible ? 'active' : 'inactive');
    // this.renderer.removeClass(target, visible ? 'inactive' : 'active');
  }


  handleScrollforVidPhto(event: ScrollEvent) {

    if (event.isReachingBottom) {
      console.log("Scroll event binding scrollableVidPhtos");
      var vpval = this.currentvp;
      if(this.rmi == 9 && vpval == 0){
        this.tpc_photosrecent = this.photocontentrecent[0];
        this.tpcp_photosrecent = this.tpc_photosrecent["total pages count"];
        if (this.tpcp_photosrecent == undefined) {
          this.tpcp_photosrecent = this.tpc_photosrecent["totalpagecount"];
        }
        try{
          this.tpcp_photosrecent=parseInt(this.tpcp_photosrecent);
        }catch(e){

        }
      }else  if(this.rmi == 9 && vpval != 0){
        this.tpc_photosmost = this.photocontentmost[0];
        this.tpcp_photosmost = this.tpc_photosmost["total pages count"];
        if (this.tpcp_photosmost == undefined) {
          this.tpcp_photosmost = this.tpc_photosmost["totalpagecount"];
        }
        try{
          this.tpcp_photosmost=parseInt(this.tpcp_photosmost);
        }catch(e){

        }
      }else  if(this.rmi == 8 && vpval == 0){
        this.tpc_videosrecent = this.videocontentrecent[0];
        this.tpcp_videosrecent = this.tpc_videosrecent["total pages count"];
        if (this.tpcp_videosrecent == undefined) {
          this.tpcp_videosrecent = this.tpc_videosrecent["totalpagecount"];
        }
        try{
          this.tpcp_videosrecent=parseInt(this.tpcp_videosrecent);
        }catch(e){

        }
      }else  if(this.rmi == 8 && vpval != 0){
        this.tpc_videosmost = this.videocontentmost[0];
        this.tpcp_videosmost = this.tpc_videosmost["total pages count"];
        if (this.tpcp_videosmost == undefined) {
          this.tpcp_videosmost = this.tpc_videosmost["totalpagecount"];
        }
        try{
          this.tpcp_videosmost=parseInt(this.tpcp_videosmost);
        }catch(e){

        }
      }
      if (this.vparray[0] != 'undefined') {
        this.tpc = this.vparray[0].val;
        this.tpcp = this.tpc[0]["total pages count"];
        if (this.tpcp == undefined) {
          this.tpcp = this.tpc[0]["totalpagecount"];
        }
      }
      this.scrollableVidPhtos();
    }




  }
  scrollableVidPhtos = (function () {
    // this.getAD();

    var executedvp = false;

    return function () {
      if (!executedvp && ((this.currentvp == 0 && (this.pg_photosrecent < this.tpcp_photosrecent))
      || (this.currentvp == 1 && (this.pg_photosmost < this.tpcp_photosmost))
      || (this.currentvp == 0 && (this.pg_videosrecent < this.tpcp_videosrecent))
      || (this.currentvp == 1 && (this.pg_videosmost < this.tpcp_videosmost)))) {
        this.getAD();
        executedvp = true;
        this.getScreenSize();
        var cData;
        cData = this.item.tabs[this.currentvp].url;
        var pgnum = 1;
        if(this.rmi == 9 && this.currentvp == 0 && (this.pg_photosrecent < this.tpcp_photosrecent)){
          pgnum=this.pg_photosrecent;
        }else if(this.rmi == 9 && this.currentvp == 1 && (this.pg_photosmost < this.tpcp_photosmost)){
          pgnum=this.pg_photosmost;
        }else if(this.rmi == 8 && this.currentvp == 0 && (this.pg_videosrecent < this.tpcp_videosrecent)){
          pgnum=this.pg_videosrecent;
        }else if(this.rmi == 8 && this.currentvp == 1 && (this.pg_videosmost < this.tpcp_videosmost)){
          pgnum=this.pg_videosmost;
        }
        cData = this.unlServiceService.updateURLParameter(cData, "page", pgnum);
        if (!cData.includes("cit=")) {
          cData = this.unlServiceService.updateURLParameter(cData, "cit", this.unlServiceService.getTermId());
        } else {
          cData = this.unlServiceService.updateURLParameter(cData, "cit", this.unlServiceService.getTermId());
        }
        if (this.vidTermId != 'all' && this.rmi == 8) {
          cData = this.unlServiceService.updateURLParameter(cData, "args[0]", this.vidTermId);
        }
        if (this.vidTermId != 'all' && this.rmi == 9) {
          cData = this.unlServiceService.updateURLParameter(cData, "args[0]", this.vidTermId);
        }
        cData = this.unlServiceService.updateURLParameter(cData, "limit", "10");
        this.spinnerService.show();
      
        this.http.get(cData).subscribe(
          (val: any[]) => {
            //console.log(val);
            this.vparray[0].val = this.vparray[0].val.concat(val);
            for (let i = 0; i < this.vparray[0].val.length; i++) {
              if (this.vparray[0].val[i].type == "videos live") {
                var cUrlImg = this.vparray[0].val[i].image_cache;
                if (!cUrlImg.endsWith(".png") && !cUrlImg.endsWith(".jpg")) {
                  var imgche = this.vparray[0].val[i].image_cache;
                  var live_video_thumb = this.vparray[0].val[i].live_video_thumb.split("files/");
                  var imageURL = imgche + live_video_thumb[1];
                  this.vparray[0].val[i].image_cache = imageURL;
                }
              } else if (this.vparray[0].val[i].type == "Video") {
                this.vparray[0].val[i].image_cache = this.vparray[0].val[i].image_cache.replace('service_default', 'service_mobile1');
              }
            }
            var vpval = this.currentvp;
            if(this.rmi == 9 && vpval == 0){
              for(let k of val){
                this.photocontentrecent.push(k);
              }
              this.photocontentrecent.forEach((element, index) => {
                if (element.type != undefined && element.type == 'ad') this.photocontentrecent.splice(index, 1);
              });
              if ((this.pg_photosrecent + 1) == this.tpcp_photosrecent) {
                this.openSnackBar(true);
              }
              this.rendervidphotoad(this.photocontentrecent);
              this.pg_photosrecent++;
            }
            else if(this.rmi == 9 && vpval == 1){
              for(let k of val){
                this.photocontentmost.push(k);
              }
              this.photocontentmost.forEach((element, index) => {
                if (element.type != undefined && element.type == 'ad') this.photocontentmost.splice(index, 1);
              });
              if ((this.pg_photosmost + 1) == this.tpcp_photosmost) {
                this.openSnackBar(true);
              }
              this.rendervidphotoad(this.photocontentmost);
              this.pg_photosmost++;
            }

           
            if(this.rmi == 8 && vpval == 0){
              for(let k of val){
                this.videocontentrecent.push(k);
              }
              this.videocontentrecent.forEach((element, index) => {
                if (element.type != undefined && element.type == 'ad') this.videocontentrecent.splice(index, 1);
              });
              this.rendervidphotoad(this.videocontentrecent);
              this.pg_videosrecent++;
            }
            else if(this.rmi == 8 && vpval == 1){
              for(let k of val){
                this.videocontentmost.push(k);
              }
              this.videocontentmost.forEach((element, index) => {
                if (element.type != undefined && element.type == 'ad') this.videocontentmost.splice(index, 1);
              });
              this.rendervidphotoad(this.videocontentmost);
              this.pg_videosmost++;
            }
            this.vpcontent = this.vparray[0].val;
            // if ((this.pg + 1) == this.tpcp) {
            //   this.openSnackBar(true);
            // }
            this.spinnerService.hide();
            this.adJsonLenth = this.adJsonContent.length;
            
            // this.pg++;
            this.urlnum++;
            this.viewallurlNumpc++;
            executedvp = false;

          },
          error => {
          }
        );

      }
      // snackbar
     
    };

  })();


  onPlayerReady(api: VgAPI) {
    this.api = api;
    var vid = document.getElementById("vgp");
    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(
      () => {
        // Set the video to the beginning
        // alert("metadata loaded");
        var mutebutton = document.getElementById("mutevideo");
        this.ismuted = false;
        // mutebutton.click();
        var html = '<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        mutebutton.innerHTML = html;
      }
    );
    // this.api.fsAPI.toggleFullscreen(vid);
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
      }
    );
    this.subscriptions.push(this.controlsHidden.isHidden.subscribe(this.onHideControls.bind(this)));

    this.api.getDefaultMedia().subscriptions.pause.subscribe(() => {
      this.overLayT = false;
    })

    this.api.getDefaultMedia().subscriptions.play.subscribe(() => {
      this.overLayT = true;
      // setTimeout(()=>{ this.overLayT=false}, 4090)
    })
    this.api.getDefaultMedia().subscriptions.progress.subscribe(() => {
      this.conPP = false;
    })
    screen.orientation.onchange = function () {
      /* logs 'portrait' or 'landscape' */
      var t = screen.orientation.type.match(/\w+/)[0];
      var elem = document.getElementById("vgp");
      function tFullscreen() {
        this.toggleFullScreen()
      }
      try {
        var my: any;
        if (t == "landscape") {
          try {
            window["my"].unlvideo.toggleScrn(true);
          } catch (e) {

          }
        } else if (t == "portrait") {
          window["my"].unlvideo.toggleScrn(false);
        }
      } catch (e) {

      }
    };



  }

  ngDestroy(): void {
    this.currentSub.unsubscribe();
    this.currentSub1.unsubscribe();
  }

  MuteAudio(event) {
    try {
      var target = event.target || event.srcElement || event.currentTarget;
      console.log("Mutevideoelement");
      var element = target.children[0];
      var vid = <HTMLVideoElement>document.getElementById("videoautoplay");
      if (!this.ismuted) {
        var html = '<div aria-label="mute" class="icon vg-icon-volume_off" role="button" tabindex="0" aria-valuetext="muted"></div>';
        vid.volume = 0;
        vid.muted = true;
        this.ismuted = true;
        target.innerHTML = html;

      } else {
        vid.volume = 1;
        vid.muted = false;
        this.ismuted = false;
        var html = '<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        target.innerHTML = html;

      }
    } catch (e) {
      alert(e.Message);
    }
  }
  pauseVG() {
    this.conPP = true;
    this.api.pause();
  }
  playVG() {
    this.overLayT = true;
    this.conH();
    this.api.play();
  }
  setoncanplay() {
    var vid = <HTMLVideoElement>document.getElementById("videoautoplay");
    // alert(vid.muted);
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    // event.preventDefault();
  }
  onHideControls(state: boolean) {
    console.log('Are controls hidden?', state);
  }
  ngOnDestroy() {
    this._routelistner.unsubscribe();
    this.getrmdetails = {};
    this.rmdetailsarray = [];
    this.getrmdetailsarray = [];
    this.vparray = [];
    // if (this.isModalOpen == false) {
    //   window.history.forward();
    // }
    this.subscriptions.forEach(s => s.unsubscribe());
    this.twindow.my.unlvideo.toggleScrn = null;
    this.scrollPosition = $(".ng-sidebar__content").scrollTop();
    localStorage.setItem("scrollPosition", this.scrollPosition);

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.getScreenSize();
  }
  applyOrientation() {
    if (window.innerHeight < window.innerWidth) {
      var vid = document.getElementById("vgp");

      this.isPortrait = false;
    } else if (window.innerHeight > window.innerWidth) {
      this.isPortrait = true;
    }
  }
  isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    if (bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth))
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  };
  adImpression2(event) {
    var target = event.target || event.srcElement || event.currentTarget;
  }
  adImpression(event, imp, i) {
    var target = event.target || event.srcElement || event.currentTarget;
    if (this.isInViewport(target)) {
      this.adImparr.push(i);
      var imppixelarr = imp.impixels;
      for (i in imppixelarr) {
        this.http.get(imppixelarr[i]).subscribe(val => {
          // alert(i)
        });
      }
      var fireindex = this.countInArray(this.adImparr, i);
      if (i == 1 && this.rmi == 0) {
        if (fireindex == 3) {
          this.http.get(imp.impixels).subscribe(val => {
            // alert(i)
          })
        }

      }
      else {
        if (fireindex == 2) {
          this.http.get(imp.impixels).subscribe(val => {
            // alert(i)
          })
        }

      }
    }
  }
  countInArray(array, what) {
    var count = 0;
    for (var i = 0; i < array.length; i++) {
      if (array[i] === what) {
        count++;
      }
    }
    return count;
  }
  conH() {
    this.conPP = true;
    setTimeout(() => { if (this.overLayT) this.conPP = false; }, 4000)
  }

  isFullScreen(): boolean {
    const fsDoc = <FsDocument>document;

    return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
  }
  toggleFullScreen(): void {
    const fsDoc = <FsDocument>document;

    if (!this.isFullScreen()) {
      const fsDocElem = <FsDocumentElement>document.getElementById("vgp");

      if (fsDocElem.requestFullscreen)
        fsDocElem.requestFullscreen();
      else if (fsDocElem.msRequestFullscreen)
        fsDocElem.msRequestFullscreen();
      else if (fsDocElem.mozRequestFullScreen)
        fsDocElem.mozRequestFullScreen();
      else if (fsDocElem.webkitRequestFullscreen)
        fsDocElem.webkitRequestFullscreen();
    } else {
      if (fsDoc.exitFullscreen)
        fsDoc.exitFullscreen();
      else if (fsDoc.msExitFullscreen)
        fsDoc.msExitFullscreen();
      else if (fsDoc.mozCancelFullScreen)
        fsDoc.mozCancelFullScreen();
      else if (fsDoc.webkitExitFullscreen)
        fsDoc.webkitExitFullscreen();
    }
  }
  setFullScreen(full: boolean): void {
    if (full) {
      if (!this.isFullScreen()) {
        this.toggleFullScreen();
      }
    } else {
      if (this.isFullScreen()) {
        this.toggleFullScreen();
      }
    }
    /*if (full !== this.isFullScreen())
      this.toggleFullScreen();*/
  }
  handleMissingImage(event: Event, obj: any) {
    // console.log(obj);
    try {
      obj.image_cache = 'assets/no-image.png';
    } catch (e) {

    }
  }

  updateSearch(newSearch: string) {
    this.currentMenuStateService.updateCurrentState({ search: newSearch });
  }

  getCurrentState() {
    console.log('working1');
    this.currentSub = this.currentMenuStateService.currentState$.subscribe(res => {
      this.issearch = res.search === 'search';
      console.log('working2');
      console.log(res)
      console.log(this.currentMenu)
      if (res.menu !== this.currentMenu) {
         this.handleLoading();
      }
      this.currentMenu = res.menu;
    });
  }

  handleLoading() {
    setTimeout(() => {
      this.viewLoading = false;
    },4000)
  }

  openModal12(e: any) {
    this.videoForCpDc = e.videos[0].url;
    this.isModalOpen1 = true;
  }

  closeModal12() {
    this.isModalOpen1 = false;
  }

  handleClick = (event: Event) => {
    // alert("this.imaAds.ima.adsManager.getState()");
    // console.log(this.imaAds.ima.adsManager)
    //alert('Click is from inside vg-ima-ads');
    let element = event.target as HTMLElement;

    while (element) {
      if (element.tagName === 'VG-IMA-ADS') {
        alert('Click is from inside vg-ima-ads');
        this.showAdPlayIcon = true;
        return;
      }
      element = element.parentElement;
    }
  }


  resumeAd() {
    this.showAdPlayIcon1 = false;
    this.showAdPlayIcon  = false
    console.log('sssssss');
    console.log(this.imaAds)
    // if (this.imaAds && this.imaAds.ima && this.imaAds.ima.adsManager) {
    //   this.showAdPlayIcon = false;
    //   this.imaAds.ima.adsManager.resume();
    // }
    document.getElementsByName('vg-ima-ads').forEach( res => {
      res.style
    })
  }

}
@Injectable()
export class modalClose implements CanDeactivate<DynamicContentComponentd>{
  canDeactivate(component: DynamicContentComponentd,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!component.isModalOpen) {
      return component.isModalOpen;
    } else {
      return true;
    }
  }
}
export class LightboxEx {

}
/*screen.orientation.onchange = function (){

};*/
// screen.orientation.onchange = function (){
//   /* logs 'portrait' or 'landscape' */
//   console.log(screen.orientation.type.match(/\w+/)[0]);
//   var t=screen.orientation.type.match(/\w+/)[0];
//   var elem=document.getElementById("vgp");
//   try{
//   if(t == "landscape"){
//     if (elem.requestFullscreen) {
//       elem.requestFullscreen();
//     }
//     else if (elem['mozRequestFullScreen']) {
//       elem['mozRequestFullScreen']();
//     } else if (elem['webkitRequestFullscreen']) {
//       elem['webkitRequestFullscreen']();
//     }else if (elem['msRequestFullscreen']) { /* IE/Edge */
//       elem['msRequestFullscreen']();
//     }
//   }else if(t == "portrait"){

//     if (document.exitFullscreen) {
//       document.exitFullscreen();
//     } else if (document['mozCancelFullScreen']) { /* Firefox */
//       document['mozCancelFullScreen()'];
//     } else if (document['webkitExitFullscreen']) { /* Chrome, Safari and Opera */
//       document['webkitExitFullscreen()'];
//     } else if (document['msExitFullscreen']) { /* IE/Edge */
//       document['msExitFullscreen()'];
//     }
//   }
// }catch(e){

// }
// };


